{
  "common": {
    "or": "or"
  },
  "general": {
    "share": "Share"
  },
  "actions": {
    "abbreviation": "AC",
    "action": "Action",
    "actions": "Actions",
    "createAction": "Add Action",
    "deleteAction": "Delete Action",
    "editAction": "Edit Action"
  },
  "analytics": {
    "title": "Usage Metrics",
    "dau": "Daily Active Users",
    "mau": "Monthly Active Users",
    "projectInteractions": "Project Interactions",
    "projectChanges": "Project Changes",
    "uniqueUsers": "Unique Users",
    "changes": "Changes",
    "last7Days": "Last 7 days",
    "last30Days": "Last 30 days",
    "last90Days": "Last 90 days",
    "last180Days": "Last 180 days",
    "last365Days": "Last 365 days",
    "last6Months": "Last 6 months",
    "last12Months": "Last 12 months",
    "projectName": "Project",
    "lastInteraction": "Last Unique Interaction",
    "lastChange": "Last Change",
    "totalInteractions": "Total Unique Interactions",
    "totalChanges": "Total Changes",
    "selectProject": "Select project",
    "allProjects": "All projects",
    "noData": "No data available for the selected period",
    "changesOn": "Changes on",
    "changesBreakdown": "Changes by project",
    "lastOperation": "Last Operation"
  },
  "companyVolatility": {
    "tabTitle": "Volatility"
  },
  "volatilityAnalytics": {
    "title": "Volatility Analytics",
    "tabActivities": "Activities",
    "tabMilestones": "Milestones",
    "andMore": "+{count} more",
    "summaryProjects": "Projects",
    "summaryItems": "Items",
    "summaryAvgDrift": "Avg. Drift",
    "summaryMedianDrift": "Median Drift",
    "summaryAvgChanges": "Avg. Changes",
    "summaryMedianChanges": "Median Changes",
    "propertyFilters": "Project Properties"
  },
  "activityVolatility": {
    "columnDeadlineDrift": "Deadline Drift",
    "columnDeadlineChanges": "Deadline Changes",
    "columnMaxShift": "Max Shift",
    "columnTimesRed": "Times Red",
    "columnCompletionDelay": "Completion Delay",
    "columnStateChanges": "State Changes",
    "columnStatusChanges": "Status Changes",
    "days": "d",
    "noActivities": "No activities match the selected filters",
    "timelineTitle": "Activity Timeline",
    "timelineNoEvents": "No events recorded for this activity",
    "eventCreated": "Created",
    "eventDeadlineChange": "Deadline changed",
    "eventStateChange": "State changed",
    "eventStatusChange": "Status changed",
    "currentDeadline": "Current deadline",
    "scatterTitle": "Deadline Drift vs. Changes",
    "scatterXAxis": "Deadline Drift (days)",
    "scatterYAxis": "Deadline Changes"
  },
  "milestoneVolatility": {
    "columnDeadlineDrift": "Deadline Drift",
    "columnDeadlineChanges": "Deadline Changes",
    "columnMaxShift": "Max Shift",
    "columnTimesRed": "Times Red",
    "columnCompletionDelay": "Completion Delay",
    "columnStateChanges": "State Changes",
    "columnStatusChanges": "Status Changes",
    "columnPhaseName": "Phase",
    "columnMilestoneType": "Type",
    "milestoneTypeFinal": "Final",
    "milestoneTypeIntermediate": "Intermediate",
    "days": "d",
    "noMilestones": "No milestones match the selected filters",
    "timelineTitle": "Milestone Timeline",
    "timelineNoEvents": "No events recorded for this milestone",
    "eventCreated": "Created",
    "eventDeadlineChange": "Deadline changed",
    "eventStateChange": "State changed",
    "eventStatusChange": "Status changed",
    "currentDeadline": "Current deadline",
    "scatterTitle": "Deadline Drift vs. Changes",
    "scatterXAxis": "Deadline Drift (days)",
    "scatterYAxis": "Deadline Changes"
  },
  "activity": {
    "abbreviation": "A",
    "action": "Action",
    "actions": "Actions",
    "activities": "activities",
    "activity": "Activity",
    "activityIsNotRequired": "Activity is not required",
    "activityIsRequired": "Activity is required",
    "activityStatusUnplannedDescription": "This activity's status cannot be updated because the phase is not yet planned. To change the status of this activity, the activity's phase should be set to planned",
    "activityStatusWarning": "The activity will be automatically set to the status 'planned'",
    "activityUsed": "Activity Used",
    "activityWillBeUpdated": "Activity will be updated",
    "addActivity": "Add activity",
    "addActivityLinkTitle": "Add connection",
    "addApprover": "Add approver",
    "addCompletionCriterion": "Add completion criterion",
    "addNewActivity": "Add new activity",
    "addPredecessor": "Add predecessor",
    "addSuccessor": "Add successor",
    "addTags": "Add tags",
    "addTopics": "Add topics",
    "approvers": "Approvers",
    "changeHistory": "Change history",
    "completedActivities": "Completed Activities",
    "completionUser": "Responsible upon completion",
    "confirmStatePlanned": "The activity will be set automatically to 'planned'",
    "confirmStateUnderway": "The phase will be set automatically to 'in progress'",
    "deleteActivity": "Delete Activity",
    "deleteActivityAdditionalText": "Predecessors/successors chains and document input/output will be potentially broken.",
    "deleteActivityCriterion": "Delete Activity Criterion",
    "deleteActivityCriterionBody": "This activity is connected to others and therefore that relationship will also be removed. You cannot undo this action.",
    "deleteActivityCriterionTitle": "Are you sure you want to delete this activity criterion?",
    "deleteActivityLinkTitle": "Delete connection",
    "deleteApprover": "Delete approver",
    "deletedUser": "Deleted User with ID:",
    "description": "Description",
    "dueDate": "Due date: {date}",
    "editActivity": "Edit activity",
    "editActivityLinkTitle": "Edit connection",
    "editApprover": "Edit approver",
    "goToCompanyLevelActivity": "Go to library activity",
    "initiallyPlanned": "Initially planned",
    "isFavorite": "Favorite",
    "libraryDrift": {
      "tooltip": "Library activity has changed since this activity was created. Consider updating.",
      "confirm": {
        "title": "Update activity from library",
        "subtitle": "The activity will be replaced with a fresh copy from the library. Local changes will be lost.",
        "warning": "This action cannot be undone.",
        "action": "Confirm",
        "successToast": "Updated from library.",
        "errorToast": "Could not update from library. Please try again."
      }
    },
    "linksAndTools": "Links & Tools",
    "milestone": "Milestone",
    "newAction": "New Action",
    "newApproval": "New Approval",
    "nextActivities": "Next Activities",
    "notes": "Notes",
    "number": "Number",
    "optionalTitle": "optional",
    "plannedDueDate": "Planned due date",
    "position": "Position",
    "predecessor": "Predecessor",
    "predecessors": "Predecessors",
    "projectActivities": "Project Activities",
    "projectDocuments": "Project Documents",
    "projectMilestones": "Project Milestones",
    "requiredTitle": "required",
    "resetDescription": "Reset description",
    "resetResponsible": "Reset responsible",
    "resetTitle": "Reset title",
    "responsible": "Responsible",
    "selectStatus": "Select status",
    "specialAssignment": "Special assignment",
    "state": "State",
    "status": "Status",
    "successor": "Successor",
    "successors": "Successors",
    "tags": "Tags",
    "title": "Title",
    "topics": "Topics",
    "warnChangeDueDate": "One or more completion criteria and one or more actions will be affected by the change of the due date. They will be set to the due date of the activity.",
    "warnChangeDueDateAction": "One or more actions will be affected by the change of the due date. They will be set to the due date of the activity.",
    "warnChangeDueDateCC": "One or more completion criteria will be affected by the change of the due date. They will be set to the due date of the activity.",
    "watcher": "Watcher",
    "watchers": "Watchers"
  },
  "approvers": {
    "activityApproved": "Activity approved",
    "activityNotPlanned": "Activity not planned",
    "addedApprover": "{name} has been selected as an approver",
    "approver": "Approver",
    "approvers": "Approvers",
    "descriptionActivity": "An activity can only switch to 'done' if all approvers approved. The approvers can change the status when activity is planned.",
    "descriptionMilestone": "A milestone can only switch to 'done' if all approvers approved. The approvers can change the status when milestone is planned.",
    "goToApproversList": "Go to approvers list page",
    "milestoneApproved": "Milestone approved",
    "milestoneNotPlanned": "Milestone not planned",
    "new": "New approver",
    "pending": "Approver must approve",
    "requestApproval": "Request approval",
    "rejected": "Approver rejected",
    "selectApprovers": "SELECT APPROVERS"
  },
  "button": {
    "add": "Add",
    "addNew": "Add new",
    "addEditor": "Add Editor",
    "apply": "Apply",
    "back": "Back",
    "backToActions": "Back to actions",
    "backToActivityList": "Back to Activity list",
    "backToActivityPage": "Back to Activity",
    "backToCompletionCriteria": "Back to completion criteria",
    "backToMilestonePage": "Back to Milestone",
    "backToProjectPage": "Back to Project page",
    "backToTemplatePage": "Back to Template page",
    "cancel": "Cancel",
    "clear": "Clear",
    "close": "Close",
    "columns": "Columns",
    "confirm": "Confirm",
    "copy": "Copy",
    "copyToClipboard": "Copy all to clipboard",
    "create": "Create",
    "cutConnection": "Cut Connection",
    "delete": "Delete",
    "deleteRelations": "Delete",
    "keepRelations": "Keep",
    "discard": "Discard",
    "done": "Done",
    "edit": "Edit",
    "enable": "Enable",
    "filters": "Filters",
    "groups": "Grouping",
    "information": "Information",
    "manage": "Manage",
    "next": "Next",
    "open": "Open",
    "optional": "Optional",
    "others": "Others",
    "previous": "Previous",
    "proceed": "Proceed",
    "protect": "Protect",
    "remove": "Remove",
    "removeFromVariant": "Remove from child",
    "replace": "Replace",
    "required": "Required",
    "reset": "Reset",
    "restore": "Restore",
    "save": "Save",
    "searchProperties": "Searchsettings",
    "split": "Split",
    "toProject": "Navigate to project",
    "unlink": "Unlink",
    "update": "Update",
    "updateStatusAndDues": "Update Status And Dues",
    "view": "View",
    "viewAll": "View All",
    "yesDelete": "Yes, delete",
    "yesProceed": "Yes, proceed"
  },
  "calendar": {
    "country": "Country",
    "region": "Region",
    "state": "State",
    "title": "Calendar (Holidays)"
  },
  "catchUpBanner": {
    "title": "What's new since",
    "whatsNew": "What's new",
    "catchUp": "Catch up",
    "heresWhat": "Here's what happened since",
    "youMissed": "You missed {count} update | You missed {count} updates",
    "forYou": "For You",
    "other": "Other",
    "dismiss": "Dismiss"
  },
  "comments": {
    "addComment": "Add new comment",
    "comment": "Comment",
    "comments": "Comments",
    "edited": "Edited {time}",
    "noComments": "No comments",
    "noUsersFound": "No users found",
    "text": "Text"
  },
  "entityReferences": {
    "meetingReferences": "Meeting References",
    "meetingReference": "meeting reference",
    "meetingSummaryWithReferences": "meeting summary with entity references",
    "noReferences": "No meeting references yet"
  },
  "company": {
    "activity": "Company activity",
    "company": "Company",
    "noLabel": "No label",
    "withoutScopes": "Without scopes",
    "projectTitle": "Project Title",
    "updateProjectOwnerWarning": "The old owner will lose its ownership, but will still be a member of the project (and will keep all its assignments in the project).",
    "updateTemplateOwnerWarning": "The old owner will lose its ownership.",
    "openCreatedActivityTitle": "Activity created",
    "openCreatedActivitySubtitle": "Would you like to open the activity now?"
  },
  "checklist": {
    "addRows": "Add rows",
    "addRowsHint": "Enter one row name per line.",
    "addRowsPlaceholder": "One name per line",
    "addStep": "Add step",
    "checked": "Checked",
    "checklist": "Checklist",
    "checklistSteps": "Checklist steps",
    "completedOn": "Completed on",
    "confirmSwitchFromIndividual": "The individual rows of this checklist and all their checkmarks will be deleted.",
    "confirmSwitchPoolToIndividual": "The rows and checkmarks stay, but the checklist is detached from the project row pool — later pool changes will no longer be applied here.",
    "confirmSwitchPoolToNone": "All checkmarks of this checklist will be deleted.",
    "confirmSwitchTitle": "Change row source",
    "deleteChecklist": "Delete checklist",
    "deleteChecklistTitle": "Delete checklist",
    "deletePoolRowWarning": "The row and its checkmarks in all pool-based checklists of this project will be deleted. This can be undone via the project history.",
    "deleteRowTitle": "Delete row",
    "deleteRowWarning": "The row and all its checkmarks will be deleted.",
    "deleteStepTitle": "Delete step",
    "deleteStepWarning": "The step and all its checkmarks will be deleted.",
    "dueDate": "Due date",
    "editStructure": "Edit structure",
    "emptyStateText": "Choose where the rows (units) of this checklist come from: use the project-wide row pool or define individual rows for this activity. The checklist steps form the columns of the grid.",
    "emptyStateTextReadonly": "No checklist was set up for this activity.",
    "emptyStateTitle": "No checklist configured",
    "entityCell": "Checklist cell",
    "entityPoolRow": "Checklist pool row",
    "entityRow": "Checklist row",
    "entityStep": "Checklist step",
    "loadFailed": "The checklist couldn't be loaded.",
    "name": "Name",
    "noRowsYet": "No rows yet.",
    "notCreated": "No checklist created",
    "openChecklist": "Open checklist",
    "openChecklistSteps": "Open checklist steps",
    "openPoolEditor": "Manage row pool",
    "openToCreate": "Open to set up the checklist",
    "openToCreateStep": "Open to create your first checklist step",
    "overdue": "Overdue",
    "poolEditorDescription": "These rows are shared by all activity checklists in this project that use the row pool. Deleting a row also removes its checkmarks from all pool-based checklists (undoable via the project history).",
    "poolEditorTitle": "Checklist row pool",
    "poolRowsManagedInSettings": "The rows are managed in the project settings and are shared by all pool-based checklists.",
    "progress": "Progress",
    "resetToParent": "Inherit from parent again",
    "retry": "Retry",
    "row": "Row",
    "rowSource": "Rows come from",
    "rowSourceIndividual": "Individual rows",
    "rowSourceNone": "None",
    "rowSourcePool": "Project row pool",
    "rowSourceValues": {
      "individual": "Individual rows",
      "none": "None",
      "pool": "Project row pool"
    },
    "rows": "Rows",
    "rowsManagedInProjects": "Rows & check-offs are added per project",
    "setDueDate": "Set due date",
    "step": "Step",
    "stepTitlePlaceholder": "Step title",
    "steps": "Steps",
    "stepsEditorDescription": "Steps defined here become the columns of the activity checklist when this template is used in a project.",
    "stepsEditorDescriptionLibrary": "Steps defined here are pushed to all template activities derived from this library activity.",
    "stepsEditorEmpty": "No checklist steps yet.",
    "stepsInheritanceBrokenHint": "This checklist no longer inherits from the parent activity.",
    "stepsInheritedHint": "The steps are inherited from the parent activity. Editing here detaches the whole checklist from the parent.",
    "stepsNotCreated": "No checklist steps created",
    "title": "Title"
  },
  "completionCriterion": {
    "abbreviation": "CC",
    "addCompletionCriterion": "Add completion criterion",
    "addCriteria": "Add criteria",
    "addSpecialAssignment": "Add special assignment",
    "completionCriteria": "Completion Criteria",
    "completionCriteriaHasBeenEdited": "The exit criteria have been processed successfully",
    "completionCriterion": "Completion criterion",
    "convertCompletionCriterionToActivityTitle": "Convert completion criterion to activity",
    "convertCompletionCriterionToActivitySubtitle": "This action will remove the completion criterion and create a new activity instead. Are you sure to proceed?",
    "convertActionToActivityTitle": "Convert action to activity",
    "convertActionToActivitySubtitle": "This action will remove the action and create a new activity instead. Are you sure to proceed?",
    "criteriaName": "Criteria name",
    "dateSetManually": "The date is set manually.",
    "deleteCompletionCriteria": "Delete completion criteria",
    "deleteCompletionCriterion": "Delete completion criterion",
    "description": "Description",
    "dueDate": "Due date",
    "editCompletionCriteria": "Edit Completion Criteria",
    "editCompletionCriterion": "Edit completion criterion",
    "function": "Function",
    "inheritedFromActivity": "Inherited from activity",
    "manualDueDate": "Manual due date",
    "notCreated": "No completion criteria created",
    "openToCreate": "Open to create your first completion criteria",
    "responsible": "Responsible",
    "specialAssignmentText": "This is a special assignment",
    "title": "Title"
  },
  "confirm": {
    "areYouSure": "Are you sure you want to {action}?",
    "areYouSureDelete": "The {thing} will be deleted. The action cannot be undone! Are you sure you want to delete it?",
    "areYouSureDeleteSoft": "Are you sure you want to delete this {thing}?",
    "areYouSureDuplicate": "The {thing} will be duplicated. The action cannot be undone! Are you sure you want to duplicate it?",
    "areYouSureDuplicateMultiple": "Selected {thing} will be duplicated. The action cannot be undone! Are you sure you want to duplicate them?",
    "areYouSurePredecessorWarning": "There are some project documents that are used as input from the predecessor you want to delete. The documents will stay in your activity but will have the input value removed. Are you sure you want to proceed?",
    "areYouSureMilestoneWithActivitiesWarning": "There are activities connected to this milestone. Deleting this milestone will remove all connections to these activities. Are you sure you want to proceed?",
    "areYouSureProceedActivityWarning": "There are some open approvals and / or open child elements! If you continue all child elements will be closed, and all open approvals will be deleted! Are you sure you want to proceed?",
    "areYouSureProceedPhaseWarning": "There are some open approvals and / or open child elements! If you continue all child elements will be closed, and all open approvals will be deleted! Are you sure you want to proceed?",
    "areYouSureProceedWarningMultiActivities": "If there are some open approvals, it will be deleted and / or open child elements, it will be closed! Are you sure you want to proceed?",
    "keepOrDeleteViolatedRelations": "This move puts predecessor/successor relations or milestone connections out of order. Keep them (they stay on the map, shown red and dashed) or delete them?",
    "deleteViolatedRelations": "This move puts predecessor/successor relations or milestone connections out of order. They will be deleted.",
    "deleteCriterion": "delete this criterion permanently",
    "deleteThisMilestone": "delete this milestone",
    "save": "Are you sure you want to save your changes?",
    "willBeDeleted": "{action} will be deleted",
    "usedInTemplatesDetach": "This {thing} is still used in templates. Deleting it cuts their connection to the library: in those templates it becomes an individual item."
  },
  "contextBar": {
    "actionDetailPage": "Go to action detail page",
    "actionsListPage": "Go to actions list page",
    "activityDelete": "Delete activity",
    "activityDetailPage": "Go to activity detail page",
    "activityDuplicate": "Duplicate activity",
    "activityFavorite": "Toggle activity favorite",
    "activityFocus": "Focus activity",
    "activityLinkDelete": "Delete relationship",
    "activityReplace": "Replace company activity",
    "activitySummary": "AI generated activity summary",
    "activityUpdateFromLibrary": "Update activity from library",
    "addDocument": "Add new",
    "approversAndWatchers": "Approvers & Watchers",
    "addDocumentExisting": "Add existing document",
    "addLink": "Add new",
    "addLinkExisting": "Add existing link",
    "basicDetails": "Basic Details",
    "ccDetailPage": "Go to completions criterion detail page",
    "ccListPage": "Go to completion criteria page",
    "checklistPage": "Go to checklist page",
    "close": "Close",
    "closeActionCreation": "Discard action creation",
    "closeCCCreation": "Discard completion criterion creation",
    "convertActionToActivity": "Convert action to activity",
    "convertCompletionCriterionToActivity": "Convert completion criterion to activity",
    "createAction": "Create new action",
    "createCC": "Create new completion criterion",
    "deleteAction": "Delete action",
    "deleteCC": "Delete completion criterion",
    "details": "Details",
    "distribute": "Distribute content of phase evenly",
    "editDocument": "Edit document",
    "editLink": "Edit link",
    "empty": "No items to display",
    "exportTaskToTodo": "Export task to Microsoft Todo",
    "exportToTodo": "Export to Microsoft Todo",
    "inheritFromActivity": "Inherit from activity",
    "listDocuments": "Go to documents list page",
    "listLinks": "Go to links list page",
    "milestoneDetailPage": "Go to milestone detail page",
    "setManualDueDate": "Set due date manually",
    "milestoneFocus": "Focus milestone",
    "mirroredActivityRemove": "Remove mirrored activity",
    "more": "More",
    "moreOptions": "More options",
    "moveAction": "Move action to other activity",
    "moveCC": "Move completion criterion to other activity",
    "noComments": "No comments yet. Click to add.",
    "noDescription": "No description yet.",
    "phaseDelete": "Delete phase",
    "phaseFocus": "Focus phase",
    "phaseSummary": "AI generated phase summary",
    "planningDetails": "Planning Details",
    "projectPage": "Go to project map page",
    "tagsAndTopics": "Tags & Topics",
    "showFullTitle": "Show full title",
    "showSingleLineTitle": "Show single line title",
    "showIcon": "Show icon",
    "showText": "Show text",
    "toDetails": "to Details",
    "workstreamDelete": "Delete workstream",
    "workstreamFocus": "Focus workstream",
    "workstreamSummary": "AI generated workstream summary"
  },
  "datePicker": {
    "from": "From",
    "to": "To"
  },
  "dialog": {
    "areYouSureYouWantToDelete": "Are you sure you want to delete it? This action cannot be undone.",
    "attentionNeeded": "Attention needed",
    "cannotBeDeleted": "{type} cannot be deleted",
    "firstRemoveFromAll": "Please first remove the {links} from all the {relation} to delete it. \n {relation}: {usedIn}",
    "isUsedInOthers": "The selected {type} is used in one or more {relation}",
    "willBeDeleted": "{type} will be deleted"
  },
  "expandableText": {
    "showLess": "Show less",
    "showMore": "Show more"
  },
  "documentCreateModal": {
    "addDocument": "Add new document",
    "addLink": "Add link",
    "addProjectDocument": "Add new document",
    "addProjectDocumentTitle": "Add new project document",
    "editDocument": "Edit document",
    "editProjectDocument": "Edit project document",
    "link": "Link",
    "manipulate": "Transform URL",
    "relativePath": "Relative Path",
    "relativePathPlaceholder": "e.g., documents/file.pdf",
    "slogan": "Please enter the title of the file you wish to save and select the corresponding document type  on the drop-down menu beside. You can also add a link below if applicable.",
    "title": "Title",
    "titlePlaceholder": "Please fill in title",
    "type": "Type"
  },
  "removeUnreferencedModal": {
    "removeButton": "Remove unused",
    "links": {
      "title": "Remove unused links",
      "success": "Successfully removed { count } links",
      "project": {
        "subtitle": "This action will remove all links from the project that are not referenced by any activity.",
        "subtitle2": "{ count } links will be removed from the project."
      },
      "template": {
        "subtitle": "This action will remove all links from the template that are not referenced by any activity.",
        "subtitle2": "{ count } links will be removed from the template."
      }
    },
    "documents": {
      "title": "Remove unused documents",
      "success": "Successfully removed { count } documents",
      "project": {
        "subtitle": "This action will remove all documents from the project that are not referenced by any activity.",
        "subtitle2": "{ count } documents will be removed from the project."
      },
      "template": {
        "subtitle": "This action will remove all documents from the template that are not referenced by any activity.",
        "subtitle2": "{ count } documents will be removed from the template."
      }
    }
  },
  "selectFromCompanyModal": {
    "links": {
      "title": "Select links & tools from company",
      "empty": "There are no company links & tools left to add to this template.",
      "success": "Successfully added { count } links from the company",
      "failed": "These links could not be added: { items }"
    },
    "documents": {
      "title": "Select documents from company",
      "empty": "There are no company documents left to add to this template.",
      "success": "Successfully added { count } documents from the company",
      "failed": "These documents could not be added: { items }"
    }
  },
  "editActivityModal": {
    "addSpecialAssignment": "Add special assignment",
    "required": "Required"
  },
  "errors": {
    "aValueMustBeEdited": "A value must be edited",
    "activityDeadlineAfterPhase": "Activity deadline is after phase deadline",
    "activityOutsideTemplate": "Activity would be moved outside the template",
    "functionExists": "A function with this name already exists.",
    "invalidEmail": "Invalid email {email}",
    "noAccessToActivity": "You have no access to this activity",
    "noDataFound": "No data found",
    "noFunctionFound": "Function does not exist",
    "notImplemented": "This is not implemented yet, please come back later",
    "popupsMustBeEnabled": "Popups must be enabled in this app for the PDF export to work.",
    "selectOption": "You must select an option before adding",
    "somethingWentWrong": "Something went wrong...",
    "wrongActivityState": "Cannot move activity in state '{activityState}' to phase in state '{phaseState}'"
  },
  "files": {
    "abbreviation": "DOC",
    "addDocument": "Add Document",
    "addLinksAndTools": "Add Links and Tools",
    "allDocuments": "All Documents",
    "allLinksAndTools": "All Links and Tools",
    "allTags": "All Tags",
    "allTopics": "All Topics",
    "anyAssetUsedInProjectLocation": "Any assets used in projects will live here.",
    "cutConnectionToPredecessorSubtitle": "Are you sure you want to cut the connection of the project document? This action cannot be undone!",
    "cutConnectionToPredecessorTitle": "Cut predecessor connection",
    "deleteDocument": "Delete document",
    "deleteLink": "Delete Links and Tool",
    "deleteLinkSubtitle": "The Link will be deleted from the activity. This action cannot be undone! Are you sure you want to delete it?",
    "document": "Document",
    "documentHasBeenLinkedSuccessfully": "Document has been linked successfully.",
    "linkHasBeenAttachedSuccessfully": "Link has been attached successfully",
    "documentHasBeenUnlinkedSuccessfully": "Document has been unlinked successfully.",
    "documentsReordered": "Documents have been re-ordered",
    "documentHasBeenUpdated": "Document has been updated",
    "documents": "Documents",
    "fileName": "File Name",
    "fileType": "File Type",
    "fromPredecessors": "From Predecessors",
    "goToSharepoint": "Go to sharepoint",
    "input": "Input",
    "link": "Link",
    "links": "Links and Tools",
    "linkDocument": "Link Document",
    "linkHasBeenRemovedFromActivity": "Link was removed from activity",
    "linksReordered": "Links have been re-ordered",
    "manageInput": "Manage Input",
    "manageInputSubtitle": "Select the activity from which you want to link the document.",
    "noCutConnectionPossibleWarningDescription": "This document does not have any predecessor connections to cut",
    "noCutConnectionPossibleWarningTitle": "Cutting connection to predecessor cannot be executed",
    "noDocumentFound": "No Documents Found",
    "noLinksFound": "No Links Found",
    "output": "Output",
    "pleaseTryAgainOrAddAnotherLink": "Please, try again or add another link to this project.",
    "pleaseTryAgainOrLinkAnotherDocument": "Please, try again or link another document.",
    "projectDocument": "Project Document",
    "projectDocuments": "Project Documents",
    "projectLevelLinksAndTools": "Project Level Links and Tools",
    "selectFromPredecessors": "Select from Predecessors",
    "standardDocument": "Standard document",
    "startByLinkingAFile": "Start by linking a file",
    "startCreatingByUploadingFiles": "Start creating by uploading files.",
    "tagOrTopicHasBeenRemovedFromActivity": "Tag/Topic was removed from activity",
    "tagOrTopicHasBeenAttachedSuccessfully": "Tag/Topic has been attached successfully",
    "templateFiles": "Template Files",
    "templateLevelLinksAndTools": "Template Level Links and Tools",
    "companyLevelLinksAndTools": "Company Level Links and Tools",
    "companyLevelDocuments": "Company Level Documents",
    "typeInADocumentName": "Type in a document's name.",
    "typeInALinkName": "Type in a link's name.",
    "typeInATagName": "Type in a tag's name.",
    "typeInATopicName": "Type in a topic's name.",
    "yourSearchDidNotMatchAnyDocument": "Your search \"{query}\" did not match any documents.",
    "yourSearchDidNotMatchAnyLink": "Your search \"{query}\" did not match any links."
  },
  "form": {
    "pleaseSelect": "Please select",
    "select": "Select",
    "typeToSearch": "Type to search",
    "resetForm": "Reset form"
  },
  "function": {
    "addNewFunction": "Add new function",
    "cannotDeleteTemplateUse": "The selected company level function is used in one or more templates.",
    "color": "Color",
    "companyFunction": "Company Function",
    "confirmRemoval": "Do you really want to remove the function {name}?",
    "confirmedRemoval": "Function was removed",
    "createdBy": "Created by",
    "customColor": "Custom color",
    "customColorHex": "Hex value",
    "customColorInvalid": "Enter a valid hex color (#RRGGBB)",
    "deleteFunction": "Delete Function",
    "editFunction": "Edit Function",
    "function": "Function",
    "functions": "Functions",
    "functionsCounted": "no functions | {n} function | {n} functions",
    "individual": "Individual",
    "label": "Number color",
    "lastUpdated": "Last updated",
    "level": "Level",
    "name": "Name",
    "newFunction": "New Function",
    "notDefined": "Not defined",
    "override": "Override",
    "overview": "Overview",
    "removePreviouslySetFunction": "Vorher eingestellte Funktion entfernen",
    "resetAllOverrides": "Reset all overrides",
    "selectFromCompany": "Select from company",
    "thisCriterionHasNoFunction": "This completion criterion has no selected function",
    "title": "Title",
    "user": "User"
  },
  "glossary": {
    "activity": "Activity",
    "deleted": "[deleted]",
    "edit": "Edit",
    "emailAddress": "Email address",
    "implementationManager": "Responsible",
    "link": "Connection",
    "no": "No",
    "noResponsibleAssigned": "No responsible assigned",
    "number": "Number",
    "phase": "Phase",
    "phases": "Phases",
    "project": "Project",
    "projectFunction": "Function",
    "predecessor": "Predecessor",
    "today": "Today",
    "url": "URL",
    "warning": "Warning!",
    "workstream": "Workstream",
    "workstreams": "Workstreams",
    "yes": "Yes"
  },
  "operations": {
    "history": {
      "changedFields": "{changed_fields}",
      "changedManyFields": "{changed_fields} and other fields",
      "action": {
        "addComment": "Added a comment to action",
        "updateComment": "Updated the comment of action",
        "removeComment": "Removed a comment from action"
      },
      "activityAction": {
        "addComment": "Added a comment to action",
        "updateComment": "Updated the comment of action",
        "removeComment": "Removed a comment from action"
      },
      "activity": {
        "addAction": "Added an action to activity",
        "addApprover": "Added an approver to activity",
        "addComment": "Added a comment to activity",
        "addChecklistRow": "Added a checklist row to activity",
        "addChecklistStep": "Added a checklist step to activity",
        "addCompletionCriterion": "Added a completion criterion to activity",
        "addSuccessor": "Added a successor to activity",
        "addTag": "Added tag to activity",
        "addPredecessor": "Added a predecessor to activity",
        "addWatcher": "Added a watcher to activity",
        "addDocument": "Added a document to activity",
        "addLink": "Added a link to activity",
        "convertCompletionCriterionToActivity": "Converted completion criterion to activity",
        "convertActionToActivity": "Converted action to activity",
        "createActivity": "Created activity",
        "duplicateActivity": "Created activity as a duplicate",
        "duplicateActivities": "Duplicated various activities through multiselect",
        "duplicateActivitiesRelated": {
          "predecessor": "Updated predecessors as a result of connected activity duplication",
          "successor": "Updated successors as a result of connected activity duplication"
        },
        "updateActivity": "Changed <span class='changed-fields'>{changed_fields}</span> on activity",
        "updateActivities": "Changed <span class='changed-fields'>{changed_fields}</span> on various activities through multiselect",
        "updateAction": "Updated the action of activity",
        "updateApprover": "Updated the approver of activity",
        "updateChecklistCell": "Updated a checklist cell on activity",
        "updateChecklistRow": "Updated a checklist row on activity",
        "updateChecklistRowSource": "Changed the checklist row source of activity",
        "updateChecklistStep": "Updated a checklist step on activity",
        "updateComment": "Updated the comment of activity",
        "updateCompletionCriterion": "Updated a completion criterion on activity",
        "updateDocument": "Updated a document on activity",
        "updateLink": "Updated a link on activity",
        "removeActivity": "Removed activity",
        "removeActivities": "Removed various activities through multiselect",
        "removeActivitiesRelated": {
          "predecessor": "Updated predecessors as a result of connected activity removal",
          "successor": "Updated successors as a result of connected activity removal"
        },
        "removeAction": "Removed action",
        "removeChecklistRow": "Removed a checklist row from activity",
        "removeChecklistStep": "Removed a checklist step from activity",
        "removeComment": "Removed a comment from activity",
        "removeCompletionCriterion": "Removed a completion criterion from activity",
        "removeSuccessor": "Removed a successor from activity",
        "removePredecessor": "Removed a predecessor from activity",
        "removeApprover": "Removed an approver from activity",
        "removeLink": "Removed a link from activity",
        "removeDocument": "Removed a document from activity",
        "removeWatcher": "Removed a watcher from activity",
        "removeTag": "Removed tag from activity",
        "toggleFavorite": "Changed favorite state on activity",
        "updateFromLibrary": "Updated activity from library"
      },
      "completionCriterion": {
        "addComment": "Added a comment to completion criterion",
        "updateComment": "Updated the comment of completion criterion",
        "removeComment": "Removed a comment from completion criterion"
      },
      "activityCompletionCriterion": {
        "addComment": "Added a comment to completion criterion",
        "updateComment": "Updated the comment of completion criterion",
        "removeComment": "Removed a comment from completion criterion"
      },
      "phase": {
        "compressPhase": "Phase compressed",
        "createPhase": "Created phase",
        "updatePhase": "Changed <span class='changed-fields'>{changed_fields}</span> on phase",
        "deletePhase": "Removed phase",
        "shiftPhaseElements": "Performed space tool on phase (preserve phase length)"
      },
      "milestone": {
        "updateMilestone": "Changed <span class='changed-fields'>{changed_fields}</span> on milestone",
        "createMilestone": "Created milestone",
        "deleteMilestone": "Milestone removed",
        "addApprover": "Added an approver to milestone",
        "updateApprover": "Updated the approver of milestone",
        "removeApprover": "Removed an approver from milestone",
        "addComment": "Added a comment to milestone",
        "updateComment": "Updated the comment of milestone",
        "removeComment": "Removed a comment from milestone"
      },
      "project": {
        "updateProject": "Changed <span class='changed-fields'>{changed_fields}</span> on project",
        "copyProject": "Created a copy of the project",
        "reorderProjectElements": "Changed order of elements on project",
        "shiftProjectElements": "Performed space tool on project (adjust phase length)",
        "addMembers": "Added members to project",
        "removeMember": "Removed member from project",
        "leaveProject": "Member left the project",
        "addProjectChecklistRow": "Added a row to the checklist row pool",
        "updateProjectChecklistRow": "Updated a row of the checklist row pool",
        "removeProjectChecklistRow": "Removed a row from the checklist row pool"
      },
      "projectFunction": {
        "createProjectFunction": "Added a function to project",
        "updateProjectFunction": "Changed <span class='changed-fields'>{changed_fields}</span> on project function",
        "removeProjectFunction": "Removed a function from project",
        "replaceProjectFunction": "Replaced a project function"
      },
      "link": {
        "addLinkToProject": "Added a link to project",
        "updateLink": "Changed <span class='changed-fields'>{changed_fields}</span> on link",
        "removeLink": "Removed a link from project",
        "removeUnreferencedLinks": "Removed unused links"
      },
      "document": {
        "addDocumentToProject": "Added a document to project",
        "updateDocument": "Changed <span class='changed-fields'>{changed_fields}</span> on document",
        "removeDocument": "Removed a document from project",
        "removeUnreferencedDocuments": "Removed unused documents"
      },
      "workstream": {
        "createWorkstream": "Created workstream",
        "deleteWorkstream": "Removed workstream",
        "updateWorkstream": "Changed <span class='changed-fields'>{changed_fields}</span> on workstream"
      },
      "meetingSummary": {
        "createEntityReferences": "Added meeting references to meeting summary",
        "removeEntityReference": "Removed a meeting reference from meeting summary"
      }
    }
  },
  "entities": {
    "history": {
      "activity": {
        "addAction": "Added an action to activity",
        "addApprover": "Added an approver to this activity",
        "addCompletionCriterion": "Added a completion criterion to this activity",
        "addSuccessor": "Added a successor to this activity",
        "addPredecessor": "Added a predecessor to this activity",
        "addWatcher": "Added a watcher to this activity",
        "addDocument": "Added a document to this activity",
        "addLink": "Added a link to this activity",
        "createActivity": "Created this activity",
        "duplicateActivity": "Created this activity as a duplicate",
        "duplicateActivities": "Created this activity as a duplicate through multiselect",
        "updateActivity": "Changed <span class='changed-fields'>{changed_fields}</span> on this activity",
        "updateActivities": "Changed <span class='changed-fields'>{changed_fields}</span> on this activity through multiselect",
        "updateAction": "Updated the action of this activity",
        "updateApprover": "Updated the approver of this activity",
        "updateCompletionCriterion": "Updated a completion criterion on this activity",
        "updateDocument": "Updated a document on this activity",
        "updateLink": "Updated a link on this activity",
        "removeActivity": "Removed this activity",
        "removeActivities": "Removed this activity through multiselect",
        "removeCompletionCriterion": "Removed a completion criterion from this activity",
        "removeSuccessor": "Removed a successor from this activity",
        "removePredecessor": "Removed a predecessor from this activity",
        "removeApprover": "Removed an approver from this activity",
        "removeLink": "Removed a link from this activity",
        "removeDocument": "Removed a document from this activity",
        "removeWatcher": "Removed a watcher from this activity"
      },
      "phase": {
        "updatePhase": "Changed <span class='changed-fields'>{changed_fields}</span> on this activity through phase status change."
      },
      "milestone": {
        "updateMilestone": "Changed <span class='changed-fields'>{changed_fields}</span> on this activity through final milestone update."
      }
    }
  },
  "history": {
    "activity": {
      "updateActivities": "Multiple activities updated",
      "removeActivities": "Multiple activities deleted",
      "duplicateActivities": "Multiple activities duplicated"
    },
    "supportedOperationType": {
      "historyActivityAddAction": "Activity: Action added",
      "historyActivityUpdateAction": "Activity: Action updated",
      "historyActivityRemoveAction": "Activity: Action deleted",
      "historyActionAddComment": "Action: Comment added",
      "historyActionUpdateComment": "Action: Comment updated",
      "historyActionRemoveComment": "Action: Comment deleted",
      "historyActivityAddApprover": "Activity: Approver added",
      "historyActivityUpdateApprover": "Activity: Approver updated",
      "historyActivityRemoveApprover": "Activity: Approver deleted",
      "historyActivityAddCompletionCriterion": "Activity: Completion criterion added",
      "historyActivityUpdateCompletionCriterion": "Activity: Completion criterion updated",
      "historyActivityRemoveCompletionCriterion": "Activity: Completion criterion deleted",
      "historyCompletionCriterionAddComment": "Completion Criterion: Comment added",
      "historyCompletionCriterionUpdateComment": "Completion Criterion: Comment updated",
      "historyCompletionCriterionRemoveComment": "Completion Criterion: Comment deleted",
      "historyActivityAddChecklistStep": "Activity: Checklist step added",
      "historyActivityUpdateChecklistStep": "Activity: Checklist step updated",
      "historyActivityRemoveChecklistStep": "Activity: Checklist step deleted",
      "historyActivityAddChecklistRow": "Activity: Checklist row added",
      "historyActivityUpdateChecklistRow": "Activity: Checklist row updated",
      "historyActivityRemoveChecklistRow": "Activity: Checklist row deleted",
      "historyActivityUpdateChecklistCell": "Activity: Checklist cell updated",
      "historyActivityUpdateChecklistRowSource": "Activity: Checklist row source changed",
      "historyProjectAddChecklistRow": "Project: Checklist pool row added",
      "historyProjectUpdateChecklistRow": "Project: Checklist pool row updated",
      "historyProjectRemoveChecklistRow": "Project: Checklist pool row deleted",
      "historyActivityAddPredecessor": "Activity: Predecessor added",
      "historyActivityAddSuccessor": "Activity: Successor added",
      "historyActivityRemovePredecessor": "Activity: Predecessor removed",
      "historyActivityRemoveSuccessor": "Activity: Successor removed",
      "historyActivityCreateActivity": "Activity: <-- Created",
      "historyActivityUpdateActivity": "Activity: <-- Updated",
      "historyActivityRemoveActivity": "Activity: <-- Deleted",
      "historyActivityAddWatcher": "Activity: Watcher added",
      "historyActivityRemoveWatcher": "Activity: Watcher removed",
      "historyActivityUpdateActivities": "Activities: <-- Updated",
      "historyActivityRemoveActivities": "Activities: <-- Deleted",
      "historyActivityDuplicateActivities": "Activities: <-- Duplicated",
      "historyActivityAddTag": "Activity: Tag/Topic added",
      "historyActivityRemoveTag": "Activity:Tag/Topic removed",
      "historyActivityAddComment": "Activity: Comment added",
      "historyActivityUpdateComment": "Activity: Comment updated",
      "historyActivityRemoveComment": "Activity: Comment deleted",
      "historyMilestoneUpdateMilestone": "Milestone: <-- Updated",
      "historyMilestoneCreateMilestone": "Milestone: <-- Created",
      "historyMilestoneDeleteMilestone": "Milestone: <-- Deleted",
      "historyMilestoneAddComment": "Milestone: Comment added",
      "historyMilestoneUpdateComment": "Milestone: Comment updated",
      "historyMilestoneRemoveComment": "Milestone: Comment deleted",
      "historyMilestoneRelevanceDeleteMilestoneRelevance": "Milestone: Milestonerelevance removed",
      "historyPhaseCreatePhase": "Phase: <-- Created",
      "historyPhaseUpdatePhase": "Phase: <-- Updated",
      "historyPhaseDeletePhase": "Phase: <-- Deleted",
      "historyPhaseShiftPhaseElements": "Phase: <-- Performed space tool on phase (preserve phase length)",
      "historyProjectUpdateProject": "Project: <-- Details updated",
      "historyProjectShiftProjectElements": "Phase: <-- Performed space tool on project (adjust phase length)",
      "historyProjectReorderProjectElements": "Project: <-- Changed order of elements on project",
      "historyWorkstreamUpdateWorkstream": "Workstream: <-- Updated",
      "historyWorkstreamCreateWorkstream": "Workstream: <-- Created",
      "historyWorkstreamDeleteWorkstream": "Workstream: <-- Deleted",
      "historyProjectFunctionReplaceProjectFunction": "Function: Replaced by another function"
    },
    "filter": {
      "hideFilters": "Hide filters",
      "operationType": "Operationtype",
      "showFilters": "Show filters"
    },
    "changeHistory": "Change History",
    "undoOperation": {
      "title": "Undo operation",
      "subtitle": "Are you sure you want to undo the last operation?",
      "success": "Operation was successfully undone"
    },
    "replaceProjectFunction": {
      "description": "Replaced function <span class='changed-fields'>{removed}</span> with <span class='changed-fields'>{replacement}</span>",
      "affected": "Affected: {items}",
      "scope": {
        "activities": "{count} activity | {count} activities",
        "actions": "{count} action | {count} actions",
        "completionCriteria": "{count} completion criterion | {count} completion criteria",
        "approvals": "{count} approval | {count} approvals",
        "phases": "{count} phase | {count} phases",
        "watchers": "{count} watcher | {count} watchers"
      }
    }
  },
  "hidenPhasesAndWorkstreams": {
    "infoPanel": "Phases can only be hidden from the start or end of the map.",
    "showAll": "Show all"
  },
  "labels": {
    "deleteSuccess": "Label deleted from library",
    "updateSuccess": "Label updated successfully",
    "deleteWarning": "The label will be deleted for all activities in the library"
  },
  "library": {
    "activities": "Activities",
    "addToLibrary": "Add to library",
    "createChild": "Create child",
    "duplicate": "Duplicate",
    "filterByLabels": "Filter by labels",
    "goToLibrary": "Go to library",
    "hasBeenMoved": "Successfully moved to library",
    "label": "Label",
    "labels": "Labels",
    "selectFromCompanyLibrary": "Select from company library",
    "matches": "Matches",
    "more": "more",
    "usedIn": "Used in"
  },
  "libraryHistory": {
    "title": "Library History",
    "noHistory": "No history available for this activity.",
    "inheritedBadge": "Inherited",
    "brokeInheritance": "Broke inheritance on {field}",
    "restoredInheritance": "Restored inheritance on {field}",
    "filter": {
      "entityType": "Entity type",
      "user": "User",
      "allUsers": "All users"
    },
    "entityType": {
      "CompanyActivity": "Activity",
      "CompanyCompletionCriterion": "Completion criterion",
      "CompanyChecklistStep": "Checklist step",
      "CompanyDocument": "Document",
      "CompanyLink": "Link",
      "CompanyTag": "Tag",
      "CompanyActivityLabel": "Activity label",
      "CompanyFunction": "Function"
    },
    "field": {
      "title": "Title",
      "order": "Order",
      "description": "Description",
      "responsibleId": "Responsible",
      "approversIds": "Approvers",
      "watchersIds": "Watchers",
      "tagsIds": "Tags",
      "labelsIds": "Labels",
      "documentsIds": "Documents",
      "linksIds": "Links",
      "parentId": "Parent",
      "topic": "Topic",
      "mimeType": "File type",
      "relativePath": "Path",
      "link": "URL",
      "name": "Name",
      "color": "Color",
      "label": "Number color",
      "overrideTitle": "Title",
      "overrideDescription": "Description",
      "overrideResponsible": "Responsible",
      "overrideApprover": "Approver",
      "overrideWatcher": "Watcher",
      "overrideTag": "Tag",
      "overrideTopic": "Topic",
      "overrideChecklist": "Checklist"
    },
    "operationType": {
      "historyCompanyActivityCreate": "Activity: Created",
      "historyCompanyActivityUpdate": "Activity: Updated",
      "historyCompanyActivityRemove": "Activity: Deleted",
      "historyCompanyActivityDuplicate": "Activity: Duplicated",
      "historyCompanyActivityAddApprover": "Activity: Approver added",
      "historyCompanyActivityRemoveApprover": "Activity: Approver removed",
      "historyCompanyActivityAddWatcher": "Activity: Watcher added",
      "historyCompanyActivityRemoveWatcher": "Activity: Watcher removed",
      "historyCompanyActivityAddTag": "Activity: Tag added",
      "historyCompanyActivityRemoveTag": "Activity: Tag removed",
      "historyCompanyActivityAddDocument": "Activity: Document added",
      "historyCompanyActivityRemoveDocument": "Activity: Document removed",
      "historyCompanyActivityAddLink": "Activity: Link added",
      "historyCompanyActivityRemoveLink": "Activity: Link removed",
      "historyCompanyCompletionCriterionCreate": "Completion criterion: Created",
      "historyCompanyCompletionCriterionUpdate": "Completion criterion: Updated",
      "historyCompanyCompletionCriterionRemove": "Completion criterion: Deleted",
      "historyCompanyChecklistStepCreate": "Checklist step: Created",
      "historyCompanyChecklistStepUpdate": "Checklist step: Updated",
      "historyCompanyChecklistStepRemove": "Checklist step: Deleted",
      "historyCompanyDocumentCreate": "Document: Created",
      "historyCompanyDocumentUpdate": "Document: Updated",
      "historyCompanyDocumentRemove": "Document: Deleted",
      "historyCompanyLinkCreate": "Link: Created",
      "historyCompanyLinkUpdate": "Link: Updated",
      "historyCompanyLinkRemove": "Link: Deleted",
      "historyCompanyTagCreate": "Tag: Created",
      "historyCompanyTagUpdate": "Tag: Updated",
      "historyCompanyTagRemove": "Tag: Deleted",
      "historyCompanyActivityLabelCreate": "Activity label: Created",
      "historyCompanyActivityLabelUpdate": "Activity label: Updated",
      "historyCompanyActivityLabelRemove": "Activity label: Deleted",
      "historyCompanyFunctionCreate": "Function: Created",
      "historyCompanyFunctionUpdate": "Function: Updated",
      "historyCompanyFunctionRemove": "Function: Deleted"
    }
  },
  "linksAndTools": {
    "abbreviation": "Link",
    "addLink": "Add link",
    "addLinksAndTools": "Add links & tools",
    "addLinksAndToolsModalTitle": "Add new links & tools",
    "deleteLink": "Delete Link",
    "description": "Description",
    "editLinksAndTools": "Edit links & tools",
    "title": "Title",
    "titlePlaceholder": "Please fill in title",
    "type": "Type"
  },
  "locale": {
    "de": "German",
    "en": "English"
  },
  "login": {
    "backToLogin": "Back to Login",
    "checkYourEmail": "Check your email",
    "clickToResend": "Click to resend",
    "confirmPassword": "Confirm password",
    "confirmResetPassword": "Send a reset password link to the user?",
    "didNotReceive": "Didn't receive the email?",
    "email": "Email",
    "emailPlaceholder": "Enter your email",
    "forgotPassword": "Forgot password?",
    "helpText": "Problems? feel free to contact { email } if you have any questions",
    "login": "Login",
    "loginWithSSO": "Login with SSO",
    "loginWithBeeboardAccount": "Or login with beeboard account",
    "noWorries": "No worries, we'll send you reset instructions.",
    "password": "Password",
    "passwordReset": "Password reset",
    "passwordResetMessage": "Your password has been successfully reset. Click below to log in.",
    "passwordResetSent": "We sent a password reset link to {email}",
    "resetPassword": "Reset password",
    "setNewPassword": "Set new password",
    "setNewPasswordMessage": "Your new password must be different from previously used passwords.",
    "ssoWindowIsOpened": "SSO window is open. Please complete login or close the popup to try again.",
    "username": "Username",
    "wrong": "The username or password you entered is incorrect"
  },
  "map": {
    "activityGrouping": "Group stacked activities (on / off)",
    "addActivity": "Add Activity",
    "addMilestone": "Add Milestone",
    "addPhase": "Add Phase",
    "addWorkstream": "Add Workstream",
    "expandWorkstream": "Expand workstream",
    "collapseWorkstream": "Collapse workstream",
    "compressFixMilestone": "Hold this date",
    "compressTool": "Compress to phase start or end",
    "compressUnfixMilestone": "Release this date",
    "contextMenu": {
      "favoriteAdd": "Add to favorites",
      "favoriteRemove": "Remove from favorites"
    },
    "exportPDF": "Export as PDF",
    "exportToPlanner": "Export tasks to Microsoft",
    "importFromTodo": "Import from Microsoft Todo",
    "importFromMicrosoft": "Import from Microsoft",
    "importTasks": "Import tasks",
    "mirrorEntitiesIntoProject": "Mirror Entities",
    "connectionsDirect": "Show direct connections",
    "connectionsFull": "Show more connections",
    "connectionsAll": "Show all connections",
    "connectionsNone": "Show no connections",
    "connectedMilestonesNone": "Show no milestones",
    "connectedMilestonesOptional": "Show optional milestones",
    "connectedMilestonesRequired": "Show required milestones",
    "focusActivity": "Focus on activities",
    "focusToday": "Focus on today",
    "groupMembers": "{count} stacked activities",
    "hiddenByFilter": "Hidden by filter",
    "hiddenPhasesWorkstreams": "Hidden phases and workstreams",
    "hiddenWorkstreams": "Hidden workstreams",
    "hiddenWorkstreamsAndFilter": "Hidden workstreams & filter",
    "linkingTool": "Linking Tool",
    "milestoneOverlay": "Milestone overview",
    "moveTool": "Move Tool",
    "moveToolVertical": "Vertical Move Tool",
    "presentationMode": "Presentation Mode",
    "resetFilter": "Reset filters",
    "selectFilteredActivities": "Select filtered activities ({count})",
    "selectionTool": "Selection Tool",
    "spaceToolAdjustPhaseLength": "Space Tool (adjust phase length)",
    "spaceToolPreservePhaseLength": "Space Tool (preserve phase length)",
    "splitPhase": "Split Phase",
    "stateStatusFilter": "State & Status",
    "statusView": "Status view (on / off)",
    "markupTool": "Markup Pen",
    "clearMarkup": "Clear Markup",
    "undo": "Undo",
    "roles": {
      "responsible": "Responsible",
      "approver": "Approver"
    }
  },
  "message": {
    "approvalRequested": "Approval requested",
    "cannotAddToDonePhase": "This phase is already done",
    "cannotDelete": "{action} can not be deleted",
    "cannotDeletePhaseWithActivity": "The phase cannot be deleted as it has activities assigned.",
    "confirmDeletion": "Are you sure you want to delete this? This action cannot be undone.",
    "copiedSuccessfully": "{link} has been copied successfully",
    "description": "Description",
    "functionRemovalWarning": "If a responsible is selected that is already approver or watcher, the function is removed there.",
    "functionUsed": "The function cannot be deleted as it is referenced by other resources.",
    "hasBeenDeleted": "{thing} has been deleted successfully",
    "hasBeenRemoved": "{thing} has been removed successfully",
    "hasBeenRemovedFromVariant": "{thing} has been removed from the child successfully",
    "hasBeenRestored": "{thing} has been restored successfully",
    "loading": "Loading...",
    "notFound": "Nothing found",
    "of": "of",
    "removedPredecessor": "{title} removed as predecessor",
    "removedSuccessor": "{title} removed as successor",
    "saveDiscardChanges": "You have unsaved changes, do you want to save or discard them?",
    "saveSuccess": "Your changes were saved successfully",
    "savingChanges": "Saving changes, please wait...",
    "specialAssignmentText": "If a special assignment exists, the user of the responsible function is suspended for this single element.",
    "willBeDeleted": "{action} will be deleted",
    "willSendEmail": "We will send you an email"
  },
  "milestone": {
    "addApprover": "Add approver",
    "addApproverHelp": "The following user is assigned to the function. Select in the dropdown below the new user you want to assign.",
    "addMilestone": "Add Milestone",
    "approvers": "Approvers",
    "cannotFindMilestone": "Can not find milestone {milestoneId} in dict",
    "cannotRemoveActivities": "You cannot remove this milestone as it has activities",
    "cannotRemoveFinal": "You cannot remove final milestones",
    "completedMilestones": "Completed Milestones",
    "confirmStatePlanned": "The milestone will be set automatically to 'planned'",
    "confirmStateUnderway": "The phase will be set automatically to 'in progress'",
    "deleteApprover": "Delete approver",
    "deleteMilestone": "Delete Milestone",
    "description": "Description",
    "editMilestone": "Edit Milestone",
    "editNotes": "Edit Notes",
    "externalDate": {
      "label": "External date"
    },
    "focusTo": "Focus milestone",
    "intermediate": "Intermediate",
    "intermediateLabel": "(Intermediate Milestone)",
    "finalLabel": "(Final Milestone)",
    "milestone": "Milestone",
    "milestoneDescription": "Milestone Description",
    "milestoneTitle": "Milestone title",
    "nextMilestones": "Next Milestones",
    "newApprover": "New approver",
    "notes": "Notes",
    "number": "Number",
    "optionalActivities": "Optional Activities",
    "requiredActivities": "Required Activities",
    "manageActivities": "Manage Relations",
    "currentActivities": "Current Relations",
    "activitiesToAdd": "Relations to add",
    "activitiesToRemove": "Relations to remove",
    "availableActivities": "Available Activities",
    "noAvailableActivities": "No activities available to add. Activities must be in the same phase and scheduled before this milestone.",
    "activitiesWithExistingAssociation": "Activities with existing relation",
    "showActivitiesWithAssociations": "Show activities already assigned to other milestones",
    "removeFromMilestoneWarning": "This activity is currently associated with milestone \"{milestoneName}\". Adding it here will remove that association.",
    "unknownMilestone": "Unknown Milestone",
    "title": "Title"
  },
  "mimeTypeOptions": {
    "directory-folder": "Directory / Folder",
    "email": "Email",
    "generic": "Generic",
    "pdf": "PDF",
    "spreadsheet": "Spreadsheet",
    "text-document": "Text-Document",
    "url": "URL"
  },
  "monthNames": {
    "january": "January",
    "february": "February",
    "march": "March",
    "april": "April",
    "may": "May",
    "june": "June",
    "july": "July",
    "august": "August",
    "september": "September",
    "october": "October",
    "november": "November",
    "december": "December"
  },
  "moveTaskModal": {
    "actionTitle": "Move action to other activity",
    "title": "Move completion criterion to other activity",
    "description": "Only valid target activities are listed",
    "button": "Move"
  },
  "msIntegration": {
    "exportDestination": "Export Destination",
    "exportToPlanner": "Microsoft Planner (Team Collaboration)",
    "exportToTodo": "Microsoft Todo (Personal Tasks)"
  },
  "msPlannerIntegration": {
    "activityShort": "Act",
    "completionCriterionShort": "CC",
    "createExport": "Export",
    "errorMessage": "Error during export",
    "exportMode": "Export Mode",
    "exportPhase": "Export entire phase",
    "exportSelected": "Export selected activities",
    "exportSelectedCount": "Export selected activities ({count})",
    "exportSelectedNone": "Export selected activities (none selected)",
    "groupSelection": "Select group",
    "login": "Login with Microsoft Account",
    "phaseSelection": "Select phase",
    "plannerSelection": "Select planner",
    "successMessage": "Exported successfully",
    "title": "Microsoft Export",
    "includeCriteriaAsChecklist": "Include completion criteria as checklist items",
    "includeCriteriaAsChecklistHint": "Add completion criteria as checklist items within activity tasks instead of creating separate tasks",
    "noPlannersFound": "No Planner plans found. Please create a plan in Microsoft Planner first."
  },
  "msTodoIntegration": {
    "errorMessage": "Error during export to Todo",
    "successMessage": "Exported to Todo successfully",
    "todoListSelection": "Select Todo list",
    "noListsFound": "No Todo lists available",
    "noListsMessage": "No Todo lists found. Please create at least one list in Microsoft Todo before exporting.",
    "exportActivityTitle": "Export Activity to Microsoft Todo",
    "exportActivitiesTitle": "Export Activities to Microsoft Todo",
    "singleActivityExported": "Activity exported to Todo successfully",
    "activitiesExported": "{count} activities exported to Todo successfully",
    "exportError": "Failed to export activities to Todo",
    "exportWithCriteria": "Include completion criteria ({count} items)",
    "exportWithCriteriaMultiple": "Include completion criteria as checklist items",
    "andMore": "and {count} more",
    "exportTaskTitle": "Export Task to Microsoft Todo",
    "taskExported": "Task exported to Todo successfully",
    "taskExportError": "Failed to export task to Todo",
    "includeCriteriaAsChecklist": "Include completion criteria as checklist items",
    "includeCriteriaAsChecklistHint": "Add completion criteria as checklist items within activity tasks instead of creating separate tasks",
    "taskBodyActivity": "Beeboard Activity: {title}",
    "taskBodyAction": "Action from Beeboard",
    "taskBodyCompletionCriterion": "Completion Criterion from Beeboard",
    "taskBodyActivityLabel": "Activity: {title}",
    "taskBodyViewInBeeboard": "View in Beeboard: {url}",
    "taskBodyResponsible": "Responsible: {name} ({email})",
    "taskBodyContext": "Context: {context}",
    "loadingLists": "Loading todo lists..."
  },
  "msTodoImport": {
    "hideCompleted": "Hide completed",
    "noTasks": "No tasks found in this list.",
    "loadingTasks": "Loading tasks...",
    "loadTasksError": "Failed to load tasks from Todo",
    "loginError": "Login failed. Please try again.",
    "importError": "Failed to import tasks",
    "completionCriterionAdded": "Completion criterion added successfully",
    "actionAdded": "Action added successfully",
    "noActivityPermission": "You do not have permission to create activities in this project.",
    "sidebarTitle": "Import Tasks",
    "sourceTodo": "Todo",
    "sourcePlanner": "Planner",
    "sourceMeeting": "Meetings",
    "planSelection": "Select Planner plan",
    "noPlansFound": "No Planner plans found",
    "meetingSelection": "Select meeting",
    "noMeetingsFound": "No meetings with summaries found",
    "loadMeetingTodosError": "Failed to load meeting todos",
    "responsibleMenuTitle": "Assign responsible",
    "responsibleSkip": "Skip (no responsible)",
    "responsibleSuggested": "Suggested",
    "responsibleFunctions": "All functions",
    "responsibleMembers": "All members",
    "dragHint": "Drag a task onto the map to create an activity or onto an existing activity to add it as a completion criterion or action.",
    "dropOutsideMap": "Please drop the task on a valid position on the map.",
    "activityCreated": "Activity created successfully",
    "dropOnActivityTitle": "Add to Activity",
    "escToCancel": "Press ESC to cancel",
    "sourceMail": "Mail",
    "phaseNotAllowed": "You can only add activities to phases you are responsible for."
  },
  "notificationActions": {
    "addToProject": "{dispatcher} added you to project {entity}",
    "projectResponsible": "{dispatcher} made you project responsible on {entity}",
    "activityApprovalRequested": "{dispatcher} requested your approval for activity {entity}",
    "milestoneApprovalRequested": "{dispatcher} requested your approval for milestone {entity}",
    "taskAssigned": "{dispatcher} assigned you a task on {entity}",
    "functionAssigned": "{dispatcher} assigned you to function {entity} in project {parentEntity}",
    "watchedDone": "Activity {entity} that you are assigned to as watcher is done",
    "meetingEnded": "{dispatcher} has ended the meeting {entity}",
    "activityToInProgressByTask": "{dispatcher} changed activity {entity} to in progress by changing one of its tasks",
    "actionToDoneByActivity": "{dispatcher} changed action {entity} to done by changing its activity {parentEntity}",
    "completionCriterionToDoneByActivity": "{dispatcher} changed completion criterion {entity} to done by changing its activity {parentEntity}",
    "userMentionedInComment": "{dispatcher} mentioned you in a comment on {entity}",
    "commentCreated": "{dispatcher} created a comment on {entity}",
    "activityAssigned": "{dispatcher} assigned you to activity {entity}",
    "actionAssigned": "{dispatcher} assigned you action {entity} on {parentEntity}",
    "completionCriterionAssigned": "{dispatcher} assigned you a completion criterion {entity} on {parentEntity}",
    "commentUpdated": "{dispatcher} updated a comment on {entity}",
    "commentDeleted": "{dispatcher} deleted a comment on {entity}",
    "projectMailReceived": "New project mail: {entity}"
  },
  "notifications": {
    "empty": "You have no notifications",
    "markAllAsRead": "Mark all as read",
    "markAsRead": "Mark as read",
    "newNotificationPopup": "New notification",
    "newNotifications": "You have new notifications",
    "settings": "Email notification settings"
  },
  "projectUpdateFromTemplateModal": {
    "title": "Update Project from Template",
    "selectTemplate": "Select Template you want to update from",
    "selectPhases": "Select the phases you want to update",
    "projectPhases": "Project Phases",
    "templatePhases": "Template Phases",
    "finalMilestones": "Final Milestones",
    "warningTitleActivities": "The project phases scheduled for replacement contain activities that are either in progress or completed.",
    "warningTitlePhases": "The project phases scheduled for replacement are either in progress or completed.",
    "projectWillBeUpdated": "Project will be updated",
    "projectWillBeUpdatedSubtitle": "Phases and Activities scheduled for replacement will be replaced. This action cannot be undone! Are you sure?"
  },
  "addWorkstreamFromTemplateModal": {
    "title": "Add Workstream from Template",
    "selectTemplate": "Select the template you want to copy a workstream from",
    "selectWorkstream": "Select the workstream you want to add to your project",
    "availableWorkstreams": "Available Workstreams",
    "noWorkstreamsAvailable": "No workstreams available in this template",
    "mappingWorkstream": "Adding workstream",
    "projectPhases": "Project Phases",
    "templatePhases": "Template Phases",
    "dropTemplatePhases": "Drop template phases here",
    "autoMap": "Auto Map",
    "clearAll": "Clear All",
    "dragInstructions": "Drag template phases from the right column to project phases on the left to create mappings. Each project phase can receive multiple template phases.",
    "workstreamOrder": "Order",
    "phaseOrder": "Position"
  },
  "mirrorEntitiesIntoProject": {
    "title": "Mirror {entity} into project",
    "activities": "Activities",
    "milestones": "Milestones",
    "sourceProject": "Source Project",
    "targetWorkstream": "Default Target Workstream",
    "projectGroup": "Project group",
    "otherProjects": "Other projects",
    "sourceResponsibleFilter": "Filter source responsible",
    "switchTabWarningTitle": "Discard current selections?",
    "switchTabWarningDescription": "Your current selections will be lost."
  },
  "personalDashboard": {
    "backToDashboardOverview": "Back to Dashboard Overview",
    "done": "Done",
    "emptyTable": "Please make sure you are using beeboard properly.",
    "myProjects": "My Projects",
    "myTasks": "My Tasks",
    "noProjects": "No Projects Found",
    "noTasks": "No Tasks Found",
    "personalDashboard": "Personal Dashboard",
    "toDo": "To Do",
    "total": "Total",
    "viewAll": "View All",
    "viewModes": {
      "table": "Table View",
      "kanban": "Kanban Board"
    },
    "welcomeBack": "Welcome back"
  },
  "phase": {
    "addPhase": "Add phase",
    "deadline": "Deadline",
    "deadlineChangeConfirm": "Some activities and intermediate milestones may switch phases. Not Planned elements that move into a Planned or In Progress phase are set to Planned.",
    "deadlineChangeConfirmTemplate": "Some activities and intermediate milestones may switch phases. Connections to milestones outside the phase are removed automatically.",
    "deadlineChangeTooltip": "Hold the 'SHIFT' key to move the deadline further",
    "positionChangeTooltip": "Hold the 'SHIFT' key to move the activity further",
    "editPhase": "Edit phase",
    "messageCantChangePosition": "The position of the phase can not be changed because there are activities attached to it.",
    "phaseStatusWarning": "The phase will be automatically set to the status 'in progress'",
    "phaseWillBeUpdated": "Phase will be updated",
    "position": "Position",
    "positionAtFirst": "at first",
    "positionAtLast": "at last",
    "positionBefore": "before {title}",
    "splitPhase": "Split phase",
    "title": "Title",
    "milestoneTitle": "Milestone title",
    "warnSplitMilestoneAsPhase": "Phase will be splitted at position of the intermediate milestone which will become the final milestone of the new phase. If there are any connections of activities to milestones out of the new phase the connections will be removed automatically.",
    "warnSplitPhase": "Phase will be splitted at the selected position. If there are any connections of activities to milestones out of the new phase the connections will be removed automatically."
  },
  "project": {
    "active": "Active",
    "activePhase": "Active Phase",
    "address": "Address",
    "assignedToUser": "Assigned to User",
    "blankProjectDescription": "Untitled free and blank project",
    "blankProjectTitle": "Blank Project",
    "createProject": "Create Project",
    "createProjectErrors": {
      "titleBlank": "The project title must not be empty.",
      "creatorWithoutScope": "Creating a project requires at least one scope in which projects may be created.",
      "firstPhaseTooShort": "The first phase must end at least 2 days after the project start.",
      "scopesNotOfResponsible": "The project responsible must have access to every selected scope.",
      "scopesNotOfCreator": "Only scopes in which you may create projects can be selected.",
      "scopesNotOfTemplate": "The selected scopes must belong to the template.",
      "phasesNotScheduled": "Every phase needs a date for its final milestone and must be at least 2 days long."
    },
    "dueDate": "Due Date",
    "editProject": "Edit project",
    "copyProject": "Copy Project",
    "copyOfProject": "Copy of {project}",
    "projectCopySuccess": "Project {originalProjectTitle} was successfully copied as {copiedProjectTitle}.",
    "projectTitle": "Project title",
    "endOfFirstPhase": "End of first Phase",
    "exportExcel": "Export all activities",
    "exportExcelSuccess": "Excel file exported successfully",
    "exportExcelError": "Error exporting Excel file",
    "viewTranscripts": "View meeting transcripts",
    "transcript": {
      "selectMeetingTranscript": "Select Meeting Transcript",
      "connectToTeams": "Connect to Microsoft Teams",
      "connectDescription": "Connect to Microsoft Teams to access meeting transcripts. You'll need to grant permissions to read online meetings and transcripts.",
      "selectMeeting": "Select a Meeting",
      "selectTranscript": "Select a Transcript",
      "selectedMeeting": "Selected Meeting",
      "participants": "Invited Participants",
      "organizer": "Organizer",
      "coorganizer": "Co-Organizer",
      "loadTranscript": "Load Transcript",
      "cancel": "Cancel",
      "showOnlyMyMeetings": "Only meetings with accessible transcript",
      "loadingMeetings": "Loading meetings...",
      "loadingTranscripts": "Loading transcripts...",
      "noMeetingsFound": "No meetings found",
      "noTranscriptsAvailable": "No transcripts available for this meeting",
      "transcriptTitle": "Transcript: {subject}",
      "speakers": "speakers",
      "entries": "entries",
      "stats": "Statistics",
      "aiSettings": "AI Settings",
      "aiSummary": "AI Summary",
      "copy": "Copy",
      "close": "Close",
      "searchTranscript": "Search transcript...",
      "groupBySpeaker": "Group by speaker",
      "noResultsFound": "No results found for \"{query}\"",
      "noTranscriptEntries": "No transcript entries found",
      "copiedToClipboard": "Copied to clipboard",
      "copyFailed": "Failed to copy to clipboard",
      "summaryError": "Unknown error occurred while fetching summary.",
      "meetingTranscripts": "Meeting Transcripts",
      "meetingSummaries": "Meeting Summaries",
      "pageDescription": "Create AI-generated summaries and extract tasks from your Microsoft Teams meeting transcripts.",
      "selectTranscriptToView": "Select a transcript to view",
      "selectTranscriptHint": "Choose a meeting and transcript from the left to display it here",
      "loadingTranscript": "Loading transcript...",
      "uploadVtt": "Upload VTT File",
      "uploadVttDescription": "Upload a VTT transcript file from your computer",
      "uploadVttButton": "Choose VTT File",
      "uploadVttDragDrop": "Drag and drop a VTT file here, or click to select",
      "uploadVttError": "Failed to upload VTT file",
      "uploadVttInvalidFormat": "Invalid VTT file format. Please upload a valid WebVTT file.",
      "uploadVttInvalidExtension": "Invalid file format. Please upload a .vtt file.",
      "noTranscriptsForSelectedMeetings": "No transcripts found for selected meetings",
      "uploadVttSuccess": "VTT file uploaded successfully",
      "manualUploadTitle": "Manual Upload",
      "manualTranscriptTitle": "Uploaded Transcript",
      "backToTeamsMeetings": "Back to Teams Meetings",
      "backToMeetings": "Back to Meetings",
      "backToTranscripts": "Back to Transcripts",
      "savedSummaries": "Saved Summaries",
      "loadingSummaries": "Loading summaries...",
      "noSavedSummaries": "No saved summaries yet",
      "noSavedSummariesHint": "Generate a summary from a meeting transcript to see it here",
      "task": "task",
      "tasks": "tasks",
      "batchMode": "Background Mode",
      "processSelected": "{count} selected",
      "processMeetings": "Process",
      "saveToProject": "Save to project",
      "projectOptional": "Optional",
      "processingMeetings": "Processing {processed} of {total} meetings",
      "cancelJob": "Cancel",
      "jobInProgress": "A job is currently running",
      "jobCancelled": "Job cancelled",
      "pending": "Processing...",
      "checkingForTranscripts": "Checking for transcripts...",
      "transcriptAvailable": "Transcript available",
      "noTranscriptAvailable": "No transcript available",
      "noAccessToTranscripts": "No access to this meeting",
      "authenticatedAs": "Authenticated as",
      "reauthenticate": "Re-authenticate",
      "authRequiredForBatch": "Microsoft authentication is required for background processing",
      "authenticateWithMicrosoft": "Authenticate with Microsoft",
      "reasoningEffort": "Reasoning Effort",
      "reasoningEffortLow": "Low (Fast)",
      "reasoningEffortMedium": "Medium (Better)",
      "useStreaming": "Live Preview",
      "generatingContent": "Generating content...",
      "generatingSummary": "Generating AI Summary...",
      "generationTimeWarning": "This may take up to several minutes depending on the model, reasoning effort, and transcript length.",
      "saveToHistory": "Save to History",
      "savedToHistory": "Saved to History",
      "saveToHistoryError": "Failed to save to history. Please try again.",
      "summaryAlreadyExistsError": "A summary already exists for this meeting in your history. Delete the existing one first to save a new one.",
      "sendEmail": "Send via Email",
      "sendToChat": "Send to Meeting Chat",
      "extractedTasks": "Extracted Tasks",
      "exportTasksToTodo": "Export Tasks to Microsoft To Do",
      "exportTasksDescription": "Export {count} extracted tasks to Microsoft To Do",
      "noTasksSelected": "No tasks selected",
      "customSummary": {
        "button": "Custom AI Summary",
        "title": "Custom AI Summary",
        "description": "Provide instructions for the structure and format of the meeting protocol. The AI will create the protocol based on the transcript.",
        "placeholder": "Describe the desired structure, e.g., \"Headings: Topics, Decisions, Tasks. Table for tasks with columns: Task, Responsible, Due Date.\"",
        "examplesLabel": "Examples:",
        "example1": "Headings: Topics, Decisions, Tasks, Next Steps",
        "example2": "Bullet points for discussion items, table for tasks",
        "example3": "Brief summary (max 5 sentences), then list of open items",
        "generate": "Generate",
        "savedPrompts": "Saved Prompts",
        "loadingPrompts": "Loading prompts...",
        "noSavedPrompts": "No saved prompts yet",
        "selectPrompt": "Select a saved prompt",
        "newPrompt": "New Prompt",
        "promptName": "Prompt Name",
        "promptNamePlaceholder": "e.g., Weekly Team Meeting Protocol",
        "savePrompt": "Save Prompt",
        "updatePrompt": "Update Prompt",
        "copyPrompt": "Copy",
        "deletePrompt": "Delete",
        "editPrompt": "Edit",
        "confirmDelete": "Are you sure you want to delete this prompt?",
        "promptSaved": "Prompt saved successfully",
        "promptUpdated": "Prompt updated successfully",
        "promptCopied": "Prompt copied successfully",
        "promptDeleted": "Prompt deleted successfully",
        "promptError": "Failed to save prompt",
        "promptNameRequired": "Please enter a name for the prompt",
        "useWithoutSaving": "Use without saving"
      },
      "email": {
        "composeEmail": "Compose Email",
        "loginRequired": "Please log in with your Microsoft account to send emails",
        "loginToSend": "Login to Send Email",
        "recipients": "Recipients",
        "recipientsPlaceholder": "email1{'@'}example.com, email2{'@'}example.com",
        "recipientsHint": "Separate multiple email addresses with commas",
        "subject": "Subject",
        "subjectPlaceholder": "Email subject",
        "body": "Email Body",
        "bodyPlaceholder": "Write your email content here...",
        "preview": "Preview",
        "send": "Send Email",
        "sending": "Sending...",
        "noRecipients": "Please enter at least one recipient",
        "sendError": "Failed to send email. Please try again.",
        "summarySubject": "Meeting Summary",
        "defaultSubject": "AI-Generated Meeting Summary"
      },
      "chat": {
        "composeMessage": "Compose Chat Message",
        "sendToMeetingChat": "This message will be sent to the meeting chat",
        "message": "Message",
        "send": "Send to Chat",
        "sendSuccess": "Message sent to chat successfully",
        "sendError": "Failed to send message to chat. Please try again.",
        "noChatId": "No chat ID available for this meeting",
        "noContent": "Please enter a message"
      },
      "export": {
        "title": "Export Tasks to Beeboard Project",
        "selectProject": "Select Project",
        "selectProjectPlaceholder": "Choose a project to export tasks to",
        "configureTasks": "Configure Tasks",
        "exportAs": "Export as",
        "activity": "Activity",
        "completionCriterion": "Completion Criterion",
        "dueDate": "Due Date",
        "optionalDueDate": "Optional Due Date",
        "parentActivity": "Parent Activity",
        "selectParentActivity": "Select parent activity",
        "exportToBeeboard": "Beeboard Export",
        "importToBeeboard": "Import tasks to project",
        "successMessage": "Tasks successfully exported to Beeboard project",
        "errorMessage": "Failed to export tasks to Beeboard. Please try again.",
        "errorLoadingProject": "Failed to load project details. Please try again.",
        "activityDescription": "Created from meeting: {meeting}\nResponsible person from meeting: {responsible}",
        "criterionDescription": "Created from meeting: {meeting}\nResponsible person from meeting: {responsible}",
        "noPermissionForActivity": "You don't have permission to create activities in this project",
        "noPermissionForCriterion": "You don't have permission to create criteria for this activity",
        "phaseDoneError": "Cannot create activity - the target phase is marked as done",
        "activityDoneError": "Cannot create criterion - the parent activity is marked as done",
        "noValidPhase": "No valid phase available in this project",
        "noValidActivities": "No activities available where you can create completion criteria",
        "noProjectsAvailable": "No projects where you have permission to create activities or criteria",
        "exportSummary": "{success} task(s) exported successfully, {failed} failed"
      },
      "meetingSummary": {
        "title": "Meeting Summaries",
        "description": "AI-powered meeting summaries processed in the background",
        "selectMeetings": "Select Meetings to Summarize",
        "selectMeetingsDescription": "Choose meetings with transcripts to generate AI summaries",
        "selectedCount": "{count} meeting(s) selected",
        "noMeetingsSelected": "No meetings selected",
        "startProcessing": "Start Processing",
        "processing": "Processing...",
        "processingMeetings": "Processing {processed} of {total} meetings",
        "jobCreated": "Summary job created successfully",
        "jobFailed": "Failed to create summary job",
        "jobCompleted": "All meetings have been processed",
        "jobCancelled": "Processing job was cancelled",
        "jobInProgress": "A job is currently running",
        "cancelJob": "Cancel",
        "pending": "Processing...",
        "viewSummaries": "View Summaries",
        "noSummaries": "No meeting summaries yet",
        "noSummariesHint": "Select meetings with transcripts and start processing to generate AI summaries",
        "summaryDate": "Meeting Date",
        "summaryCreated": "Created",
        "summarySubject": "Subject",
        "summaryParticipants": "Participants",
        "authRequired": "Enable background processing to generate AI summaries",
        "authenticateWithMicrosoft": "Enable Background Processing",
        "authenticatedAs": "Background processing enabled for {email}",
        "reauthenticate": "Re-authorize",
        "deleteSummary": "Delete Summary",
        "deleteSummaryConfirm": "Are you sure you want to delete this meeting summary together with the linked entity references? This cannot be undone.",
        "summaryDeleted": "Summary deleted successfully",
        "hasSavedSummary": "This meeting has a saved summary",
        "alreadyHasSummary": "A summary already exists for this transcript",
        "summaryExists": "Summary exists",
        "summaryTitle": "Summary",
        "editHint": "Edit the HTML content of the summary. Changes will be saved when you click Save.",
        "editSummary": "Edit Summary",
        "copySummary": "Copy Summary",
        "todos": {
          "title": "Meeting Todos",
          "description": "Action items extracted from your meetings",
          "noTodos": "No todos yet",
          "noTodosHint": "Todos will appear here after processing meetings",
          "pending": "Pending",
          "completed": "Completed",
          "dismissed": "Dismissed",
          "markComplete": "Mark as completed",
          "markDismissed": "Dismiss",
          "reopen": "Reopen",
          "deleteTodo": "Delete Todo",
          "deleteTodoConfirm": "Are you sure you want to delete this todo?",
          "todoDeleted": "Todo deleted successfully",
          "assignee": "Assignee",
          "dueDate": "Due Date",
          "fromMeeting": "From meeting",
          "statusUpdated": "Todo status updated",
          "unassigned": "Unassigned",
          "addTask": "Add Task",
          "newTaskPlaceholder": "Enter task title...",
          "descriptionLabel": "Description",
          "showMore": "Show more",
          "showLess": "Show less"
        },
        "jobs": {
          "title": "Processing Jobs",
          "description": "Background jobs for meeting summary generation",
          "noJobs": "No processing jobs",
          "status": {
            "pending": "Pending",
            "running": "Running",
            "completed": "Completed",
            "failed": "Failed",
            "cancelled": "Cancelled"
          },
          "progress": "{processed} of {total} meetings processed",
          "startedAt": "Started",
          "completedAt": "Completed",
          "viewJob": "View Details",
          "cancelJob": "Cancel Job"
        },
        "errors": {
          "loadFailed": "Failed to load meeting summaries",
          "processingFailed": "Failed to process meetings",
          "noRefreshToken": "Authentication required. Please reconnect to Microsoft Teams.",
          "noMeetingsWithTranscripts": "No meetings with transcripts available"
        }
      },
      "askAi": {
        "title": "Ask AI about this meeting",
        "emptyState": "Ask a question about what was said in this meeting. Answers are based on the transcript, with sources you can check.",
        "placeholder": "e.g. What did we decide about the deadline?",
        "send": "Ask",
        "clear": "Delete chat",
        "clearConfirmTitle": "Delete this chat?",
        "clearConfirmSubtitle": "The questions and answers about this meeting are deleted for good. The meeting summary and its transcript are not affected.",
        "sources": "Sources ({count})",
        "tab": "Ask AI"
      }
    },
    "exportOptions": "Export Options",
    "includeDocuments": "Include documents",
    "includeDocumentsHint": "Add activity documents to the export with their URLs",
    "updateFromTemplate": "Update from template",
    "addWorkstreamFromTemplate": "Add workstream from template",
    "favorites": "Favorites",
    "fillInTheDataSubtitle": "Fill in the data and start the project - *Mandatory fields",
    "fromTemplate": "From template {template}",
    "goToProject": "Go to Project",
    "imageUrl": "URL to Image",
    "image": {
      "image": "Image",
      "upload": "Upload file",
      "uploadError": "Failed to upload project picture",
      "invalidType": "Invalid file type. Allowed: JPEG, PNG, WebP, GIF",
      "clickToUpload": "Click to upload a new image"
    },
    "documentsPath": "Project Documents Path",
    "newProject": "New Project",
    "isActive": "Project is active",
    "isActiveState": "Active state",
    "isNotActive": "Project is not active",
    "calendarSync": {
      "label": "Sync to Outlook calendar",
      "enabledHint": "Project entities are mirrored to Outlook",
      "disabledHint": "Outlook calendar is not synced",
      "notConfigured": "Calendar sync isn't enabled for your organisation — contact your administrator."
    },
    "nonWorkingDays": {
      "title": "Additional days off",
      "add": "Add days off",
      "startDate": "From",
      "endDate": "To",
      "label": "Reason",
      "labelPlaceholder": "e.g. Company shutdown",
      "errorDatesRequired": "Please select a start and an end date.",
      "errorEndBeforeStart": "The end date must not be before the start date.",
      "errorLabelRequired": "Please enter a reason."
    },
    "showNotActive": "Show inactive projects",
    "noLinksAndToolsAdded": "No links & tools added",
    "noProjectDocumentsAdded": "No project documents added",
    "none": "None",
    "members": "Members",
    "number": "Number",
    "openToCreateYourFirstDocument": "Open to create your first completion criterion",
    "openToLinkYourFirstLinkAndTool": "Open to link your first link & tool",
    "parentProject": "Parent Project",
    "participating": "Participating",
    "pleaseTypeInProjectName": "Please Type in the Project Name",
    "projectCalculateMilestones": "Calculate milestones deadline based on template",
    "includeIntermediateMilestones": "Include intermediate milestones",
    "milestoneDateErrors": {
      "afterProjectStart": "At least {days} days after the project start ({date} or later)",
      "afterPreviousPhase": "At least {days} days after the final milestone of the previous phase ({date} or later)",
      "afterPreviousMilestone": "At least {days} days after the previous milestone of this phase ({date} or later)"
    },
    "projectCreatedTitle": "Project Successfully Created",
    "projectDetailsAndMandatory": "Project details and current information / *Mandatory fields",
    "projectListOverview": "Projects",
    "projectOutdated": "Project outdated, Click to refresh",
    "projectNumber": "Project Number",
    "projectResponsible": "Project Responsible",
    "projectWillBeDeleted": "Project will be deleted",
    "projectWillBeDeletedSubtitle": "This project will be deleted. This action cannot be undone! Are you sure?",
    "recommended": "Recommended",
    "replaceByFunction": "Replace by Function",
    "replaceByFunctionAlertSubtitle": "This action cannot be undone. If you want the function back later you have to assign everything manually to that function again. Are you sure that you want to proceed?",
    "replaceByFunctionAlertTitle": "The Function {functionName} will be replaced by {replacement}",
    "replaceByFunctionSubtitle": "This action is used to replace one function with another. All responsibilities from the old function will be assigned to the new function. The old function will be deleted.",
    "replaceByFunctionUndoableAlertSubtitle": "All responsibilities move to the new function and the old function is deleted. As long as this is the last change in the project, you can undo it in the change history.",
    "replaceByLibraryActivitySubtitle": "This action cannot be undone.",
    "responsible": "Responsible",
    "responsibleShort": "Responsible",
    "scope": "Scope",
    "selectFromTemplateDescription": "Pre-selected templates from Company",
    "selectFromTemplateTitle": "Select From Template",
    "selectResponsibleFirst": "Select the project responsible first",
    "selectTemplateStateSubtitle": "Choose what you want to start working on",
    "selectTemplateSubtitle": "Select the template you want to choose",
    "setMilestones": "Please set all final milestones",
    "shareLink": "Share Link",
    "startDate": "Start Date",
    "template": "Template",
    "title": "Title",
    "updatedAt": "Last changed",
    "updatedAtShort": "Changed",
    "createdAt": "Created at",
    "volume": "Volume",
    "xxx": "Placeholder"
  },
  "projectOverview": {
    "title": "Project overview",
    "backToProjectOverview": "Back to project overview",
    "projectStats": {
      "ccTarget": "Target",
      "ccCompleted": "Completed Criteria",
      "completedActivities": "Completed Activities",
      "daysUntilNextMilestone": "Days until next Milestone"
    },
    "projectDetails": {
      "title": "Project Details",
      "currentPhase": "Current Phase",
      "currentPhaseFallback": "Project is completed",
      "projectCode": "Project Code",
      "responsible": "Responsible",
      "volume": "Volume",
      "startDate": "Start Date",
      "endDate": "End Date",
      "templateMapLinkTitle": "Open Project Map Template",
      "projectMapLinkTitle": "Open Project Map"
    },
    "activityListTitle": "Next Activities",
    "milestonesListTitle": "Next Milestones",
    "historyListTitle": "Updates",
    "MeetingListTitle": "Meetings",
    "ViewAllLinkTitle": "View All"
  },
  "projectList": {
    "action": "Action",
    "activity": "Activity",
    "backToListView": "Back to list view",
    "cc": "Completion Criterion",
    "dueDate": "Due Date",
    "favorite": "Favorite",
    "favoriteYes": "Yes",
    "favoriteNo": "No",
    "finalMilestone": "Final milestone",
    "intermediateMilestone": "Intermediate milestone",
    "listView": "List view",
    "mirroredActivity": "Mirrored activity",
    "showOnlyMilestones": "Milestones",
    "showOnlyNotFinished": "Not finished",
    "showOnlyOwn": "Assigned to me",
    "noResponsible": "No Responsible",
    "noUser": "No User",
    "phase": "Phase",
    "phaseView": "Phase view",
    "project": "Project",
    "responsible": "Responsible",
    "status": "Status",
    "statusIndicator": "Status color",
    "title": "Title",
    "type": "Type",
    "user": "User",
    "views": "Views",
    "workstream": "Workstream",
    "workstreamView": "Workstream view"
  },
  "projectMembers": {
    "addUsers": "Add users",
    "addUsersSubtitle": "Select in the dropdown below the users you want to assign as project members.",
    "createUser": "Create user",
    "editor": "Editor",
    "editUser": "Edit user",
    "externalUser": "External user",
    "grantEditorRights": "Grant editor rights",
    "internalUser": "Internal user",
    "lastName": "Last name",
    "member": "Member",
    "name": "Name",
    "owner": "Owner",
    "removeEditorRights": "Remove editor rights",
    "removeUser": "Remove user",
    "removeUserSubtitle": "This user is assigned to this project. He will loose his permission to work on this project. Do you want to continue?",
    "leaveProject": "Leave project",
    "leaveProjectSubtitle": "You will lose access to this project. Do you want to continue?",
    "ssoUser": "SSO user",
    "user": "User",
    "users": "Users",
    "usersCounted": "no user | {n} user | {n} users",
    "userType": "User type"
  },
  "projectMeetings": {
    "active": "Active",
    "attendees": "Attendees",
    "changes": "Changes",
    "date": "Date",
    "deleteMeeting": "Delete meeting",
    "detailMeeting": "Meeting details",
    "detailsAndTasks": "Details & Tasks",
    "endMeeting": "End meeting",
    "ended": "Ended",
    "endedAt": "Ended at",
    "meeting": "Meeting",
    "meetingDeletedSuccessfully": "Meeting deleted successfully",
    "meetingEnded": "Meeting ended",
    "meetingFor": "Meeting for project",
    "meetingInProgress": "Meeting in progress",
    "meetingNotes": "Meeting minutes",
    "meetingStartedSuccessfully": "Meeting started successfully",
    "meetingTitle": "Meeting title",
    "meetingUpdatedSuccessfully": "Meeting updated successfully",
    "meetings": "Meetings",
    "noAttendees": "No attendees",
    "noChanges": "No changes recorded for this meeting",
    "noMeetings": "No meetings yet",
    "noSummary": "No summary available for this meeting",
    "otherAttendees": "Other attendees",
    "otherAttendeesPlaceholder": "Enter the names of attendes separated by commas",
    "selectMeeting": "Select a meeting to view details",
    "startMeeting": "Start meeting",
    "startedAt": "Started at",
    "status": "Status",
    "summary": "Summary",
    "summaryIsAttachedToTheMeeting": "Summary is attached to the meeting",
    "timeDuration": "Time & Duration",
    "viewFullSummaryAndTasks": "View Full Summary & Tasks",
    "entityMatching": {
      "matchToProject": "Match to Project",
      "match": "Match",
      "reviewTitle": "AI Entity Matching",
      "reviewSubtitle": "Review and edit AI-suggested links between summary content and project entities.",
      "description": "Description",
      "selected": "{count} of {total} selected",
      "saveSelected": "Save Selected",
      "savedSuccessfully": "Entity references saved",
      "entityReferences": "Entity References",
      "noMatchesFound": "No matching entities found in this summary",
      "aiProcessing": "AI is analyzing the summary...",
      "quote": "Quote",
      "overrideWarning": "This will replace all existing entity references",
      "cancelConfirmTitle": "Cancel AI matching?",
      "cancelConfirmSubtitle": "The AI is still processing. If you close now, the results will be lost.",
      "cancelConfirmAction": "Yes, close"
    }
  },
  "projectReports": {
    "projectReporting": "Project reporting",
    "title": "Title",
    "status": "Status",
    "passedDues": "Passed due dates",
    "phase": "Phase",
    "owner": "Owner",
    "start": "Start",
    "end": "End",
    "number": "Number",
    "totalVolume": "Total volume",
    "projectsCount": "{count} project in these scopes | {count} projects in these scopes",
    "projectsTotal": "Project | Projects",
    "milestones": "Milestone | Milestones",
    "activities": "Activity | Activities",
    "actions": "Action | Actions",
    "completionCriteria": "Completion criteria",
    "completionCriteriaShort": "Compl. Cr.",
    "legend": "Legend",
    "statusDetails": "Status Details",
    "elementOverview": "Progress",
    "criticalTasks": "Details",
    "clickToExpand": "Click to view details",
    "clickToCollapse": "Click to hide details",
    "healthCritical": "Critical",
    "healthOnTrack": "On Track",
    "sortByHealth": "Status",
    "sortByName": "Name",
    "sortByStart": "Start date",
    "sortByEnd": "End date",
    "allStatuses": "All",
    "criticalIssues": "red | red",
    "warnings": "yellow | yellow",
    "overdueItems": "overdue item | overdue items",
    "onTrack": "On track",
    "noProjectsFound": "No projects match your filters",
    "subProjects": "Sub-project | Sub-projects",
    "issuesByType": "Issues by type",
    "type": "Type",
    "overdue": "Overdue",
    "goToProject": "Go to project",
    "inactive": "Inactive",
    "viewClassic": "Classic",
    "viewCards": "New",
    "viewDetailed": "Detailed",
    "viewCompact": "Compact",
    "beta": "Beta",
    "nextMilestone": "Next milestone",
    "nextActivity": "Next activity",
    "maxDaysOverdue": "max. {count} day overdue | max. {count} days overdue",
    "healthAtRisk": "At Risk",
    "sortByOverdue": "Days overdue",
    "progressDone": "Done",
    "progressInProgress": "In progress",
    "progressNotStarted": "Not started"
  },
  "random": {
    "page": "Page",
    "pageOf": "Page {page} of {total}",
    "search": "Search",
    "viewAllResults": "View all results",
    "searchResults": "Search Results",
    "searchingFor": "Searching for",
    "noResultsFound": "No results found",
    "tryDifferentQuery": "Try a different search query",
    "foundResults": "Found {count} results"
  },
  "search": {
    "aiNoResultsDescription": "The AI search couldn't find any relevant matches. Try a different search query or go back to the map.",
    "aiNotAvailable": "AI search is not yet available. The backend endpoint is being developed.",
    "aiPoweredSemanticSearch": "AI-powered semantic search",
    "aiResults": "AI Results",
    "aiSearching": "Searching with AI...",
    "aiSearchingDescription": "Please wait while we search for relevant results using AI.",
    "aiSearchResults": "AI Search Results",
    "bestMatch": "Best match",
    "clearAiResults": "Clear AI results",
    "exactMatches": "Exact Matches",
    "noResults": "No results found",
    "noResultsDescription": "We couldn't find any matches for your search. Try our AI-powered search for better results.",
    "readyToSearchWithAi": "Ready to search with AI",
    "readyToSearchWithAiDescription": "Click the button below to find relevant results using AI-powered semantic search.",
    "relevanceScore": "Relevance Score",
    "searchPlaceholder": "Search (min. 2 chars)",
    "searchWithAi": "Search with AI",
    "tryOurAi": "Try our AI"
  },
  "roles": {
    "FORBID_EXPORT": "Forbid export",
    "LIBRARY_MANAGER": "Manage Library",
    "MANAGE_FUNCTIONS": "Manage functions",
    "MANAGE_PROJECT_RESPONSIBLE": "Manage project responsible",
    "MANAGE_SCOPES": "Manage scopes",
    "MANAGE_TEMPLATE_OWNER": "Template admin",
    "MANAGE_USERS": "Manage users",
    "MANAGE_VIEWS": "Manage views",
    "PROJECTS_WITHOUT_SCOPE": "Projects without Scope",
    "role": "Role",
    "roles": "Roles",
    "EXCLUDE_FROM_ANALYTICS": "Exclude from analytics",
    "VIEW_ANALYTICS": "View analytics",
    "VIEW_DASHBOARD": "View reports",
    "MANAGE_IN_APP_CONTENT": "Manage in-app content",
    "MANAGE_SKILLS": "Manage AI skills",
    "MANAGE_AI_MODELS": "Manage AI models"
  },
  "routes": {
    "company/functions": "Functions",
    "dashboard": "Dashboard",
    "dashboard/my-projects": "My projects",
    "dashboard/tasks": "My tasks",
    "projects": "Project",
    "projects/*/activities": "Activity",
    "projects/*/activities/*/actions": "Actions",
    "projects/*/activities/*/approvals": "Approvals",
    "projects/*/activities/*/checklist": "Checklist",
    "projects/*/activities/*/completion-criteria": "Completion Criteria",
    "projects/*/activities/*/documents": "Documents",
    "projects/*/activities/*/links-and-tools": "Links & Tools",
    "projects/*/activities/*/notes": "Notes",
    "projects/*/activities/*/predecessors": "Predecessors",
    "projects/*/activities/*/successors": "Successors",
    "projects/*/activities/*/watchers": "Watchers",
    "projects/*/milestones": "Milestone",
    "projects/*/milestones/*/approvals": "Approvals",
    "projects/*/milestones/*/notes": "Notes",
    "projects/*/settings": "Settings",
    "projects/*/settings/checklist-rows": "Checklist rows",
    "projects/*/settings/documents": "Documents",
    "projects/*/settings/editors": "Template Editors",
    "projects/*/settings/functions": "Functions",
    "projects/*/settings/links-and-tools": "Links and tools",
    "projects/*/settings/members": "Members",
    "root": "Dashboard",
    "settings": "Settings",
    "settings/company": "Company",
    "templates": "Templates",
    "templates/*/activities": "Activity",
    "templates/*/activities/*/approvers": "Approvers",
    "templates/*/activities/*/checklist-steps": "Checklist steps",
    "templates/*/activities/*/completion-criteria": "Completion Criteria",
    "templates/*/activities/*/documents": "Documents",
    "templates/*/activities/*/links-and-tools": "Links & Tools",
    "templates/*/activities/*/predecessors": "Predecessors",
    "templates/*/activities/*/successors": "Successors",
    "templates/*/activities/*/watchers": "Watchers",
    "templates/*/editors": "Template Editors",
    "templates/*/milestones": "Milestone",
    "templates/*/milestones/*/activities/optional": "Optional activities",
    "templates/*/milestones/*/activities/required": "Required activities",
    "templates/*/milestones/*/approvers": "Approvers",
    "templates/*/milestones/*/predecessors": "Predecessors",
    "templates/*/milestones/*/successors": "Successor",
    "templates/*/settings": "Settings",
    "templates/*/settings/documents": "Documents",
    "templates/*/settings/editors": "Template Editors",
    "templates/*/settings/functions": "Functions",
    "templates/*/settings/links-and-tools": "Links and tools"
  },
  "scopes": {
    "all": "All",
    "assignToAllUsers": "Assign to all users",
    "createScope": "Create scope",
    "editScope": "Edit scope",
    "pleaseTypeInScopeName": "Please, type in the scope name",
    "projectCreator": "Project creator",
    "projectReader": "Project reader",
    "removeScopeSubtitle": "Warning! The scope will be deleted, all templates, projects, and users that has this scope assigned will loose the scope!",
    "removeScopeTitle": "The scope will be deleted",
    "scope": "Scope",
    "scopes": "Scopes",
    "templateCreator": "Template creator",
    "templateReader": "Template reader"
  },
  "settings": {
    "documents": "Documents",
    "linksAndTools": "Links & Tools",
    "profile": "Profile",
    "settings": "Settings",
    "settingsOverview": "Settings overview",
    "slogan": "Manage your team function and their account permissions here.",
    "teamMembers": "Team Members"
  },
  "sideBar": {
    "assignedToMe": "Assigned to me",
    "assignedToMeTooltip": "All responsibilities highlighted",
    "days": "days",
    "favorites": "Favorites",
    "favoritesTooltip": "All activities that are a favorite",
    "hideMirrored": "Hide mirrored",
    "hideMirroredTooltip": "Hide activities and milestones mirrored from other projects",
    "filterHideModeTooltip": "Show only matches: hide activities that do not match the active filter or search instead of dimming them",
    "fromLibrary": "From library",
    "fromLibraryTooltip": "Highlight activities from the company library",
    "templateOnly": "Template only",
    "templateOnlyTooltip": "Highlight activities created in this template",
    "latestChanges": "Changed activities last ",
    "latestChangesTooltip": "All changes on activities from last days will be highlighted"
  },
  "sideNavigation": {
    "companySettings": "Settings",
    "english": "English",
    "functionsAndUsers": "Functions & users",
    "german": "German",
    "history": "History",
    "inviteColleagues": "Invite colleagues",
    "kanbanView": "Kanban board",
    "languages": "Languages",
    "library": "Library",
    "linksAndTools": "Links & tools",
    "listView": "List view",
    "logout": "Log out",
    "meetings": "Meetings",
    "myBeeboard": "My beeboard",
    "myTasks": "my tasks",
    "notifications": "Invite colleagues",
    "projectOverview": "Project overview",
    "projectDocuments": "Project documents",
    "projectMembers": "Project members",
    "projects": "Projects",
    "projectReports": "Project reporting",
    "analytics": "Usage Metrics",
    "reports": "Reports",
    "template": "Template",
    "templateEditors": "Template editors",
    "templates": "Templates",
    "userProfile": "User profile",
    "userSettings": "User settings",
    "featureRanking": "Feature Ranking",
    "more": "More"
  },
  "featureRanking": {
    "title": "Feature Ranking",
    "pageSubtitle": "Drag to reorder features by business value. Top = highest value.",
    "popupSubtitle": "Sort these features by business value. Drag to reorder. Top = highest value.",
    "allFeatures": "All Features",
    "myRanking": "My Ranking",
    "saveRanking": "Save Ranking",
    "saving": "Saving...",
    "submitRanking": "Submit Ranking",
    "skipForToday": "Skip for today",
    "emptyRanking": "You haven't ranked any features yet. The ranking popup will appear after login.",
    "devopsId": "DevOps ID",
    "featureTitle": "Title",
    "description": "Description",
    "effort": "Effort",
    "featureDate": "Date",
    "avgValue": "Avg. Value",
    "votes": "Votes",
    "showDescription": "Show details",
    "hideDescription": "Hide details",
    "rankMore": "Rank more"
  },
  "statusBadges": {
    "done": "Done",
    "inProgress": "In Progress",
    "none": "None",
    "notRequired": "Not Required",
    "planned": "Planned",
    "underway": "In Progress",
    "unplanned": "Not Planned",
    "onTrack": "On Track",
    "atRisk": "At Risk",
    "offTrack": "Off Track"
  },
  "kanban": {
    "emptyColumn": "No tasks",
    "dropHere": "Drop here to move",
    "cannotDropHere": "Cannot drop here",
    "alsoMoves": "Also moves",
    "mobileWarning": "Drag and drop works best on desktop. Tap cards to view details.",
    "legend": {
      "canDrop": "Can drop here",
      "cannotDrop": "Cannot drop here"
    },
    "validation": {
      "sameColumn": "Task is already in this column",
      "projectLoadError": "Could not load project data",
      "cannotMoveFromUnplanned": "Cannot move tasks from unplanned state",
      "cannotMoveToUnplanned": "Cannot move tasks back to unplanned",
      "childrenInProgress": "Cannot move activity to planned while children are in progress",
      "restrictedFromNotRequired": "Restricted transitions from 'Not Required' state",
      "notRequiredNotAllowed": "'Not Required' is only available for Completion Criteria",
      "transitionNotAllowed": "This state transition is not allowed"
    },
    "errors": {
      "taskNotFound": "Task not found"
    }
  },
  "projectKanban": {
    "kanbanView": "Kanban board",
    "filters": "Filters",
    "searchPlaceholder": "Search the board",
    "users": "Users",
    "cardLocked": "You don't have permission to change this item",
    "mobileHintTitle": "The Kanban board needs more space",
    "mobileHintText": "The Kanban board is only available on wider screens. Switch to the list view to work on this project on smaller displays.",
    "goToListView": "Go to list view",
    "setFunction": "Function",
    "setUser": "User",
    "workstream": "Workstream",
    "noFunction": "No function",
    "functionDefaultUser": "Function default user",
    "assignFunction": "Assign function",
    "assignUser": "Assign user",
    "resizeFilters": "Drag to resize — double-click to reset",
    "groupBy": "Group by",
    "groupByStatus": "By status",
    "groupByWorkstream": "By workstream",
    "noWorkstream": "No workstream",
    "hideDone": "Hide done",
    "newActivity": "New activity",
    "newActivityTitle": "Activity title",
    "setDate": "Date",
    "deadlineOutOfRange": "The deadline is outside the project's phases"
  },
  "projectViewSwitcher": {
    "label": "Project view",
    "list": "List",
    "board": "Board"
  },
  "statusColors": {
    "red": "red",
    "yellow": "yellow",
    "green": "green"
  },
  "statusApproval": {
    "pending": "Pending",
    "approved": "Approved",
    "rejected": "Rejected"
  },
  "table": {
    "active": "active",
    "activeFilters": "Active Filters",
    "clearAll": "Clear all filters",
    "filterBy": "Filter by",
    "groupBy": "Group by",
    "searchBy": "Search by {placeholder}",
    "search": "Search",
    "selected": "selected",
    "noEntriesFound": "No entries",
    "reset": "Reset table",
    "any": "All",
    "selectColumns": "Select columns",
    "from": "From",
    "to": "To",
    "invalidDateRange": "End date must be after start date"
  },
  "tag": {
    "addTag": "Add tag",
    "editTags": "Edit tags",
    "searchFor": "Search for tag",
    "tag": "Tag",
    "tagHasBeenAddedSuccessfully": "Tag has been added successfully",
    "tagHasBeenRemovedSuccessfully": "Tag has been removed successfully",
    "tagsHaveBeenUpdatedSuccessfully": "Tags have been updated successfully",
    "tags": "Tags",
    "title": "Title",
    "topic": "Topic"
  },
  "tagsAndTopics": {
    "addTagOrTopic": "Add new tag/topic",
    "editTagOrTopic": "Edit {thing}",
    "tags": "Tags",
    "tagsAndTopics": "Tags/Topics",
    "title": "Title",
    "titlePlaceholder": "Please fill in title",
    "type": "Type"
  },
  "task": {
    "action": "Action",
    "dueDate": "Due date: {date}",
    "project": "Project",
    "status": "Status",
    "statusPredecessors": "Predecessors lowest status",
    "title": "Title",
    "type": "Type"
  },
  "taskTypeBadges": {
    "Action": "Action",
    "Activity": "Activity",
    "CC": "CC"
  },
  "template": {
    "keepPreviousOwnerAsEditor": "Keep {name} as template editor",
    "ownerNeedsTemplateScopes": "The new owner needs Template reader in every selected scope.",
    "activitiesRenumbered": "Activities renumbered",
    "copyOfTemplate": "Copy of {template}",
    "copyTemplate": "Copy Template",
    "create": "Create template",
    "createNewProjectMap": "Create a new project map template",
    "delete": "Delete template",
    "edit": "Edit template",
    "editProjectMapTemplate": "Edit a project map template",
    "isDraftState": "Template is a draft",
    "isNotActive": "Template is not active",
    "milestonesRenumbered": "Milestones renumbered",
    "newTemplate": "New template",
    "openToReviewFindings": "Open template",
    "originNotReleased": "The template this project was created from is no longer released and cannot be used for an update.",
    "owner": "Owner",
    "pleaseTypeInTemplateName": "Please Type in the Template Name",
    "qualityCheck": "Quality check",
    "release": "Release",
    "releaseConfirmSubtitle": "Once released, this template can be used to create and update projects.",
    "releaseConfirmTitle": "Release template",
    "releaseNoFindings": "The quality check found no open issues.",
    "releaseQualityLoading": "Checking quality…",
    "releaseQualitySummary": "The quality check found {warnings} warning(s) and {hints} hint(s). You can release anyway.",
    "releaseQualityUnavailable": "The quality check could not be loaded. You can release anyway.",
    "renumberActivities": "Renumber Activities",
    "renumberMilestones": "Renumber Milestones",
    "setInactive": "Set inactive",
    "setInactiveConfirmSubtitle": "An inactive template is hidden from everyone except its owner and users with the role Template admin, cannot be used for new projects, and projects can no longer update from it. You can switch it back on later.",
    "setInactiveConfirmTitle": "Set template inactive",
    "status": "Status",
    "statusChangeFailed": "The status could not be changed",
    "statusChanged": "Status updated",
    "statusDraft": "Draft",
    "statusFilter": "Status",
    "statusInactive": "Inactive",
    "statusReleased": "Released",
    "template": "Template",
    "templateCopySuccess": "Template {originalTemplateTitle} was successfully copied as {copiedTemplateTitle}.",
    "templateHasBeenCreated": "Template has been created successfully",
    "templateList": "Template List",
    "templateListOverview": "Templates",
    "templateTitle": "Template title",
    "templateWillBeDeleted": "Template will be deleted",
    "templateWillBeDeletedSubtitle": "This template will be deleted. This action cannot be undone! Are you sure?",
    "title": "Title"
  },
  "templateEditor": {
    "keepMeAsEditor": "Keep me as template editor",
    "addUser": "Add user",
    "addUsers": "Add users",
    "addUserSubtitle": "Select in the dropdown below the new user you want to assign as template editor.",
    "addUsersSubtitle": "Select in the dropdown below the new users you want to assign as template editor.",
    "confirmOwnerAlert": "If you change the owner, your ability to own and edit this template will be lost and you cannot undo that yourself.",
    "confirmOwnerAlertKeepEditor": "You will no longer be the owner of this template, but stay an editor.",
    "confirmOwnerSubtitle": "You as the template owner will be replaced by the selected user.",
    "emptyTable": "Please make sure you are using beeboard properly.",
    "name": "Name",
    "noEditors": "No Editors Found",
    "removeUser": "Remove user",
    "removeUserSubtitle": "This user is assigned to this template. He will loose his permission to work on this template. Do you want to continue?",
    "selectUser": "Select user",
    "selectUsers": "Select users",
    "templateEditors": "Template editors",
    "templateEditorsSubtitle": "The owner of the template can add and remove other editors for this template",
    "templateOwner": "Template Owner",
    "templateOwnerSubtitle": "User who can manage and edit this template",
    "updateOwnerSubtitle": "Select in the dropdown below the new user you want to assign as template owner.",
    "user": "User",
    "users": "Users",
    "usersCounted": "no user | {n} user | {n} users"
  },
  "toolbar": {
    "labelShow": "Show labels",
    "timeLineTemplateMode": "Show grid for timeline / positions"
  },
  "topic": {
    "addTopic": "Add topic",
    "editTopics": "Edit topics",
    "searchFor": "Search for topic",
    "topic": "Topic",
    "topicHasBeenAddedSuccessfully": "Topic has been added successfully",
    "topicHasBeenRemovedSuccessfully": "Topic has been removed successfully",
    "topicsHaveBeenUpdatedSuccessfully": "Topics have been updated successfully",
    "topics": "Topics"
  },
  "users": {
    "exportToExcel": "Export to Excel",
    "firstName": "First name",
    "lastName": "Last name",
    "name": "Name",
    "userName": "Username",
    "userType": "Usertype",
    "deletedUser": "Deleted User",
    "unknownUser": "Unknown User"
  },
  "userSettings": {
    "receiveEmailNotifications": "Receive email notifications",
    "emailLanguage": "Email language",
    "receiveEmailTasksNotifications": "Receive email task notifications",
    "receiveEmailTasksThreshold": "Days in advance",
    "sectionGeneral": "General email notifications",
    "sectionGeneralHint": "Here you receive your new bell notifications (top-right) each day, if any are available.",
    "sectionTasks": "Email notifications for tasks",
    "sectionTasksHint": "Here you receive daily notifications (if any) about overdue tasks and tasks that fall within your threshold window.",
    "sectionTeams": "Microsoft Teams notifications",
    "sectionTeamsHint": "Receive your in-app notifications in real time as personal messages in Microsoft Teams. Your organisation must have the beeboard Teams app enabled for this to work.",
    "receiveTeamsNotifications": "Receive notifications in Microsoft Teams",
    "sectionSlack": "Slack notifications",
    "sectionSlackHint": "Receive your in-app notifications in real time as personal messages from the beeboard app in Slack.",
    "receiveSlackNotifications": "Receive notifications in Slack",
    "slackUserNotFound": "No Slack account was found for your email address. Slack notifications only work when your Slack account uses the same email address as your beeboard account.",
    "slackUnavailable": "Slack cannot be reached right now. Please try again later.",
    "sectionLanguage": "Language",
    "sectionLanguageHint": "",
    "profilePicture": {
      "section": "Profile Picture",
      "formats": "Supported: JPG, PNG, WebP, GIF",
      "invalidType": "Only JPG, PNG, WebP, or GIF images are supported.",
      "uploadSuccess": "Profile picture updated successfully.",
      "cropTitle": "Adjust Profile Picture",
      "cropHint": "Drag to reposition · Scroll or pinch to zoom",
      "upload": "Upload Picture",
      "remove": "Remove picture",
      "removeSuccess": "Profile picture removed successfully.",
      "removeConfirm": "Are you sure you want to remove this picture?",
      "rotate": "Rotate",
      "change": "Change",
      "syncMs": "Sync with Microsoft",
      "syncSuccess": "Profile picture synced with Microsoft.",
      "msSynced": "Synced with Microsoft"
    }
  },
  "watcher": {
    "addWatcher": "Add watcher",
    "addWatcherSubtitle": "The following user is assigned to the function. Select in the dropdown below the new user you want to assign.",
    "deleteWatcher": "Delete watcher",
    "goToWatchersList": "Go to watchers list page",
    "watcherHasBeenAddedSuccessfully": "Watcher has been added successfully",
    "watcherHasBeenRemovedSuccessfully": "Watcher has been removed successfully",
    "watcher": "Watcher",
    "watchers": "Watchers"
  },
  "weekday": {
    "monday": "Mon",
    "tuesday": "Tue",
    "wednesday": "Wed",
    "thursday": "Thu",
    "friday": "Fri",
    "saturday": "Sat",
    "sunday": "Sun"
  },
  "workstream": {
    "addWorkstreamTitle": "Add new workstream",
    "deleteWorkstream": "Delete workstream",
    "deleteWorkstreamTitle": "Delete workstream",
    "description": "Description",
    "editWorkstreamTitle": "Edit workstream",
    "order": "Order",
    "placeholder": "Name",
    "position": "Position",
    "positionAtFirst": "at first",
    "positionAtLast": "at last",
    "positionBefore": "before {title}",
    "title": "Title"
  },
  "roadmap": {
    "title": "Product Roadmap",
    "subtitle": "Big upcoming features and improvements for the platform. Not included are the small changes we constantly ship to improve user experience and adhoc feedback implementations.",
    "searchPlaceholder": "Search roadmap items...",
    "noItems": "No roadmap items found",
    "activeItems": "Active Items",
    "completedItems": "Completed Items"
  },
  "aiSkills": {
    "tabTitle": "AI Skills",
    "title": "AI Skills",
    "subtitle": "Predefined prompts and tool sets that users can invoke in chat via /slug.",
    "addSkill": "Add skill",
    "editSkill": "Edit skill",
    "noSkills": "No AI skills have been defined yet.",
    "slug": "Command",
    "slugPlaceholder": "meeting-minutes",
    "slugHint": "What users type after / in the chat to invoke this skill. Lowercase a–z, 0–9 and dashes. Can be changed later — chat history stays linked via the skill's id.",
    "name": "Name",
    "namePlaceholder": "Meeting Minutes",
    "description": "Description",
    "descriptionPlaceholder": "Summarize an attached meeting transcript into structured minutes.",
    "descriptionHint": "Shown in the skill picker — a one-liner explaining what the skill does.",
    "slots": {
      "title": "Attachment slots",
      "hint": "Define one slot per type of document this skill expects. Users get a labelled upload control per slot when they invoke the skill. Leave empty if the skill doesn't need attachments — users can still attach ad-hoc files.",
      "label": "Slot label",
      "labelPlaceholder": "Contract",
      "description": "Slot description",
      "descriptionPlaceholder": "The PDF contract you want analyzed.",
      "required": "Required",
      "multiple": "Allow multiple files",
      "add": "Add slot",
      "remove": "Remove slot",
      "moveUp": "Move up",
      "moveDown": "Move down"
    },
    "systemPrompt": "System prompt",
    "systemPromptPlaceholder": "You are a meeting-minutes assistant. Produce: attendees, decisions, action items.",
    "contexts": {
      "title": "Where can this skill be used?",
      "hint": "Project chat and template chat have different tools. Enable the contexts where this skill should be available, then choose the tools it can use in each.",
      "project": "Project chat",
      "template": "Template chat"
    },
    "toolCategory": {
      "read": "Read",
      "write": "Write",
      "system": "System",
      "orchestration": "Subtasks"
    },
    "deleteConfirmTitle": "Delete this skill?",
    "deleteConfirmMessage": "\"{name}\" will be deleted. Users will no longer be able to invoke it in chat.",
    "createSuccess": "Skill created.",
    "updateSuccess": "Skill updated.",
    "deleteSuccess": "Skill deleted.",
    "errors": {
      "nameRequired": "Name is required.",
      "promptRequired": "System prompt is required.",
      "slugPattern": "Use lowercase a–z, 0–9 and dashes. Must start with a letter or digit.",
      "contextRequired": "Pick at least one context (project chat or template chat)."
    }
  },
  "aiModels": {
    "tabTitle": "AI Models",
    "resource": {
      "sectionTitle": "AI Resources",
      "sectionSubtitle": "OpenAI accounts or Azure OpenAI resources. API keys are encrypted at rest and never returned by any endpoint.",
      "add": "Add resource",
      "createTitle": "Add AI resource",
      "editTitle": "Edit AI resource",
      "empty": "No AI resources configured yet. Add one before defining models.",
      "type": "Type",
      "typeImmutable": "Resource type is fixed after creation — create a new resource instead.",
      "endpoint": "Endpoint",
      "endpointPlaceholder": "https://contoso-ai.openai.azure.com",
      "endpointRequired": "Endpoint is required for Azure resources.",
      "apiKey": "API key",
      "apiKeyCreatePlaceholder": "sk-...",
      "apiKeyEditPlaceholder": "Leave blank to keep the existing key",
      "apiKeyHint": "Encrypted with AES-256-GCM at rest. Filling this field on edit rotates the key.",
      "apiKeyRequired": "API key is required when creating a resource.",
      "displayName": "Display name",
      "displayNamePlaceholder": "DECK OpenAI",
      "displayNameRequired": "Display name is required.",
      "editAction": "Edit / rotate key",
      "createSuccess": "AI resource created.",
      "updateSuccess": "AI resource updated.",
      "deleteSuccess": "AI resource deleted.",
      "deleteConfirmTitle": "Delete AI resource",
      "deleteConfirmMessage": "Delete '{name}'? Any models pointing at this resource must be removed first."
    },
    "model": {
      "sectionTitle": "AI Models",
      "sectionSubtitle": "Models available for use in chat. Mark which model is the default for each capability — at most one per capability.",
      "add": "Add model",
      "createTitle": "Add AI model",
      "editTitle": "Edit AI model",
      "empty": "No AI models configured yet.",
      "noResources": "No resources available. Add a resource first.",
      "noResourcesError": "Add an AI resource before creating models.",
      "resource": "Resource",
      "resourceRequired": "Pick a resource for this model.",
      "resourceImmutable": "Resource is fixed after creation.",
      "modelName": "OpenAI model id",
      "modelNamePlaceholder": "gpt-5-mini-2025-08-07",
      "modelNameHint": "The canonical model id sent to OpenAI. Must be unique within this realm.",
      "modelNameImmutable": "Model id is fixed after creation.",
      "modelNameRequired": "Model id is required.",
      "deploymentName": "Azure deployment name",
      "deploymentNamePlaceholder": "gpt-5-mini-deployment",
      "deploymentNameHint": "Optional. When set, this is the deployment name sent to Azure instead of the model id.",
      "displayName": "Display name",
      "displayNamePlaceholder": "GPT-5 mini",
      "displayNameRequired": "Display name is required.",
      "isAvailable": "Show in chat-input model selector",
      "isAvailableShort": "Available",
      "isAvailableYes": "Yes",
      "isAvailableNo": "No",
      "isAvailableHint": "When off, the model is hidden from end users but still selectable as a default for capabilities.",
      "defaultFor": "Default for capabilities",
      "defaultForHint": "Capabilities for which this model is the realm default. At most one model per capability per realm. End users can still pick any available model for the chat assistants — the default is just what's auto-selected when they don't.",
      "capabilityClaimed": "Already claimed by '{name}'. Uncheck it there first to reassign.",
      "capabilityClaimedShort": "claimed by {name}",
      "pricingTitle": "Pricing override (USD per 1M tokens)",
      "pricingHint": "Leave any field blank to use the built-in fallback for this model id. Set values to track per-tenant cost on chats. Use either a comma or a dot as the decimal separator — both work.",
      "inputPrice": "Input",
      "outputPrice": "Output",
      "cachedInputPrice": "Cached input",
      "pricePlaceholder": "e.g. 0.25",
      "priceInvalid": "Must be a non-negative number, e.g. 0.25 or 0,25.",
      "contextWindowTitle": "Context window",
      "contextWindowHint": "Total tokens the model can process. Leave blank to use the built-in value for this model id. Raising it lets meeting Q&A accept longer transcripts without a code change.",
      "contextWindowTokens": "Context window (tokens)",
      "contextWindowPlaceholder": "e.g. 400000",
      "contextWindowInvalid": "Must be a whole number of 1 or more, e.g. 400000 or 400,000.",
      "capabilities": {
        "project_assistant": "Project AI Assistant",
        "template_assistant": "Template AI Assistant",
        "meeting_summary": "Meeting summary",
        "meeting_qa": "Meeting questions (Q&A)",
        "entity_matching": "Meeting entity matching",
        "template_translate": "Template translation",
        "template_quality_check": "Template quality check",
        "company_relay": "Company AI relay"
      },
      "createSuccess": "AI model created.",
      "updateSuccess": "AI model updated.",
      "deleteSuccess": "AI model deleted.",
      "deleteConfirmTitle": "Delete AI model",
      "deleteConfirmMessage": "Delete '{name}'? Chats that use this model will silently fall back to the realm default."
    }
  },
  "aiGlossary": {
    "tabTitle": "AI Glossary",
    "title": "AI Glossary",
    "subtitle": "Canonical spellings for names and terms, so AI meeting summaries, todos and answers correct speech-recognition errors from transcripts.",
    "addTerm": "Add term",
    "editTerm": "Edit term",
    "noTerms": "No glossary terms have been defined yet.",
    "term": "Term",
    "termPlaceholder": "beeboard",
    "termHint": "The canonical spelling the AI must use.",
    "aliases": "Known mis-transcriptions",
    "aliasesPlaceholder": "B-Board\nBee Board",
    "aliasesHint": "Optional, one per line. Spellings the speech recognition typically produces for this term (max 10).",
    "note": "Note",
    "notePlaceholder": "our product name",
    "noteHint": "Optional short context shown to the AI alongside the term.",
    "createSuccess": "Glossary term created.",
    "updateSuccess": "Glossary term updated.",
    "deleteSuccess": "Glossary term deleted.",
    "deleteConfirmTitle": "Delete glossary term",
    "deleteConfirmMessage": "Delete '{name}'? The AI will no longer correct mis-transcriptions of this term.",
    "capReached": "The limit of {max} glossary terms has been reached. Delete a term before adding a new one.",
    "errors": {
      "termRequired": "Term is required.",
      "termDuplicate": "'{term}' already exists in the glossary.",
      "tooManyAliases": "At most {max} mis-transcriptions per term.",
      "aliasTooLong": "Each mis-transcription can have at most {max} characters."
    }
  },
  "customProperties": {
    "title": "Custom Properties",
    "tabTitle": "Custom Properties",
    "projectPropertiesTitle": "Additional Properties",
    "addProperty": "Add Property",
    "editProperty": "Edit Property",
    "noProperties": "No custom properties have been defined yet.",
    "name": "Name",
    "key": "Key",
    "dataType": "Data Type",
    "required": "Required",
    "actions": "Actions",
    "description": "Description",
    "defaultValue": "Default Value",
    "hasDefaultValue": "Set default value",
    "booleanDefaultValue": "Default value (True/False)",
    "keyHint": "Unique identifier for this property (cannot be changed after creation)",
    "options": "Options",
    "optionValue": "Value",
    "optionLabel": "Label",
    "addOption": "Add Option",
    "minLength": "Minimum Length",
    "maxLength": "Maximum Length",
    "minValue": "Minimum Value",
    "maxValue": "Maximum Value",
    "deleteConfirmTitle": "Delete Property",
    "deleteConfirmMessage": "Are you sure you want to delete the property '{name}'? This action cannot be undone.",
    "deleteInUseTitle": "Property in use",
    "deleteInUseMessage": "'{name}' is currently used by {count} project(s). Their values will be removed. Delete anyway?",
    "deleteInUseTemplateMessage": "'{name}' is currently used by {count} template(s). Their values will be removed. Delete anyway?",
    "deleteAnyway": "Delete anyway",
    "createSuccess": "Property created successfully",
    "updateSuccess": "Property updated successfully",
    "deleteSuccess": "Property deleted successfully",
    "loadError": "Failed to load custom properties",
    "showOnList": "Show on project list",
    "nameAndKeyRequired": "Name and Key are required fields",
    "namePlaceholder": "Enter property name",
    "keyPlaceholder": "Enter unique key",
    "setProjectProperties": "Set Project Properties",
    "setProjectPropertiesSubtitle": "Configure custom property values for this project (optional)",
    "editProjectProperties": "Edit Project Properties",
    "editProjectPropertiesSubtitle": "Edit custom property values for '{project}'",
    "dataTypes": {
      "text": "Text",
      "number": "Number",
      "date": "Date",
      "boolean": "Boolean",
      "select": "Select",
      "multiselect": "Multi-Select"
    },
    "projects": "Projects",
    "templates": "Templates",
    "showOnTemplateList": "Show on template list"
  },
  "ai": {
    "panel": {
      "title": "AI Assistant",
      "close": "Close",
      "resize": "Drag to resize"
    },
    "chat": {
      "loading": "Loading chat…",
      "starters": {
        "lead": {
          "project": "Ask me about this project — or let me change something in it.",
          "template": "Ask me about this template — or let me change something in it."
        },
        "leadReadOnly": {
          "project": "Ask me about this project.",
          "template": "Ask me about this template."
        },
        "project": {
          "dueSoon": "Which activities are due in the next two weeks?",
          "overdue": "Which activities are overdue, and who is responsible?",
          "status": "Briefly summarize where the project stands.",
          "createActivity": "Create an activity “Review designs”, due next Friday."
        },
        "template": {
          "structure": "Which phases and workstreams does this template have?",
          "firstPhase": "Which activities belong to the first phase?",
          "summary": "Summarize this template in a few sentences.",
          "createActivity": "Create an activity “Project kick-off workshop” in the first phase."
        }
      },
      "thinking": "Thinking",
      "reasoning": "Reasoning",
      "processing": "Processing",
      "subagent": {
        "statusLine": "{running} of {total} subtasks running",
        "prompt": "Prompt",
        "toolsUsed": "Tools",
        "summary": "{iterations} iterations · {tools} tools",
        "runningStatus": "Running...",
        "failed": "Failed",
        "truncated": "Hit iteration limit",
        "stopped": "Stopped",
        "errorFallback": "The subtask stopped without an error message."
      },
      "cancel": "Cancel",
      "stop": "Stop the answer",
      "running": "AI assistant is working",
      "inputPlaceholder": {
        "default": "Message... ({'@'} to mention an item)",
        "withDictation": "Message... ({'@'} to mention an item)"
      },
      "dictation": {
        "start": "Start dictation (Ctrl+D)",
        "stop": "Stop dictation (Esc)"
      },
      "newChat": "New Chat",
      "send": "Send",
      "mention": {
        "noItemsFound": "No items found"
      },
      "entityChip": {
        "notAvailable": "This reference cannot be opened from the current view."
      },
      "model": {
        "label": "Model:",
        "lockedTooltip": "A chat stays with its model. Start a new chat to use another one."
      },
      "skill": {
        "noItemsFound": "No matching skill.",
        "toolsLocked": "Tools are set by the /{slug} skill for this message.",
        "attachmentMissingTitle": "Send without required attachments?",
        "attachmentMissingMessage": "/{slug} marked these slots as required but they're empty: {slots}",
        "attachmentMissingConfirm": "Send anyway",
        "stickyActive": "is active for this chat.",
        "stop": "Stop using skill",
        "slotRequired": "(required)",
        "slotUpload": "Upload file",
        "slotUploadMultiple": "Add file",
        "slotFilledEarlier": "Provided earlier:",
        "slotFilledEarlierTooltip": "This file was uploaded earlier in this chat and is still available to the AI. Upload again to replace.",
        "collapse": "Collapse skill panel",
        "expand": "Expand skill panel",
        "collapsedFileCount": "{count} file | {count} files"
      },
      "attachments": {
        "add": "Attach file",
        "remove": "Remove attachment",
        "uploadFailed": "File upload failed",
        "waitForUpload": "Waiting for upload to finish",
        "tooMany": "Too many files — only {max} attachments per message"
      },
      "codeInterpreter": {
        "codeInput": "Code",
        "executing": "Executing code",
        "output": "Output",
        "generatedImage": "Generated image",
        "download": "Download",
        "ephemeralHint": "This image is only available in the current session. Download it now to keep it.",
        "imageUnavailable": "Image no longer available"
      },
      "steps": {
        "entity": {
          "activity": "Activity | Activities",
          "phase": "Phase | Phases",
          "milestone": "Milestone | Milestones",
          "workstream": "Workstream | Workstreams",
          "function": "Function | Functions",
          "completion_criterion": "Completion criterion | Completion criteria",
          "member": "Member | Members",
          "relation": "Dependency | Dependencies",
          "milestone_connection": "Milestone relevance | Milestone relevances",
          "approver": "Approver | Approvers",
          "document": "Project document | Project documents",
          "activity_document": "Project document | Project documents",
          "link": "Link & tool | Links & tools",
          "activity_link": "Link & tool | Links & tools"
        },
        "connector": {
          "in": "in",
          "to": "→",
          "for": "for",
          "at": "on"
        },
        "fields": {
          "title": "Title",
          "description": "Description",
          "state": "State",
          "status": "Status",
          "deadline": "Due date",
          "phase": "Phase",
          "workstream": "Workstream",
          "responsible": "Responsible",
          "duration": "Duration",
          "position": "Position",
          "name": "Name",
          "color": "Color",
          "label": "Number color",
          "parent": "Parent function",
          "user_id": "Person",
          "force_update_deadline": "force the deadline despite dependencies",
          "remove_violated_connections": "remove violated dependencies"
        },
        "reads": {
          "project": "Read the project",
          "template": "Read the process map",
          "count": "{n} lookup | {n} lookups"
        },
        "changes": "No changes | {n} change | {n} changes",
        "failed": "{n} failed",
        "stopped": "Stopped",
        "stopping": "Stopping …",
        "notRun": "not run",
        "noChange": "nothing to change",
        "failedCall": "failed",
        "untitled": "untitled",
        "showOnMap": "Show on map"
      },
      "plusMenu": {
        "title": "Attach file, web search, code interpreter",
        "webSearch": "Web search",
        "codeInterpreter": "Code interpreter"
      },
      "writeAccess": {
        "question": "May I make changes?",
        "allowOnce": "Allow once",
        "allowForChat": "Allow for this chat",
        "readOnly": "No, read only",
        "templateNoUndo": "Changes to process maps cannot be undone.",
        "decided": {
          "allowed": "Allowed for this chat",
          "allowedOnce": "Allowed once",
          "rejected": "Read only",
          "discarded": "Not run – a new message was sent",
          "pending": "Waiting for your decision"
        },
        "chip": "Changes allowed",
        "chipTooltip": "The AI assistant may make changes in this chat. Click to revoke the permission.",
        "revoke": "Revoke permission",
        "readOnlyLabel": "Read only",
        "readOnlyTooltip": {
          "project": "No edit rights in this project",
          "template": "No edit rights in this process map"
        },
        "waiting": "AI assistant is waiting for your decision"
      },
      "error": {
        "stage": {
          "send": "Your message was not sent.",
          "answer": "The answer failed.",
          "load": "The chat could not be loaded."
        },
        "reason": {
          "network": "The server cannot be reached.",
          "busy": "The previous answer is still running — wait until it has finished.",
          "files": "An attached file is no longer available — please attach it again.",
          "model": "A chat stays with its model — start a new chat to use another one.",
          "notFound": "This chat no longer exists — your next message starts a new chat.",
          "rateLimit": "The AI service is busy right now — try again in a moment.",
          "forbidden": "You do not have permission for this.",
          "unknown": "An unexpected error occurred."
        },
        "partial": "The changes made up to that point are saved.",
        "retry": "Send again",
        "continueFailed": "The answer could not be continued.",
        "revokeFailed": "The permission could not be revoked.",
        "skillFailed": "The skill could not be stopped."
      }
    },
    "conversations": {
      "title": "Chats",
      "loading": "Loading chats…",
      "empty": "No earlier chats yet.",
      "messageCount": "no messages | {n} message | {n} messages",
      "rename": "Rename",
      "delete": "Delete",
      "deleteConfirm": "Delete chat?",
      "loadFailed": "The chats could not be loaded.",
      "renameFailed": "The chat could not be renamed.",
      "deleteFailed": "The chat could not be deleted.",
      "time": {
        "justNow": "Just now",
        "minutesAgo": "{n} m ago | {n} m ago | {n} m ago",
        "hoursAgo": "{n} h ago | {n} h ago | {n} h ago",
        "daysAgo": "{n} d ago | {n} d ago | {n} d ago"
      }
    },
    "metadata": {
      "tokens": "{count} tokens",
      "cached": "{count} cached",
      "details": "Model, duration, tokens and cost",
      "duration": "{seconds} s"
    }
  },
  "zoomWarning": {
    "title": "Browser Zoom Detected",
    "message": "Your browser is currently zoomed to {zoomLevel}%.",
    "instruction": "For optimal display, we recommend resetting the zoom to 100% ({key}). You can ignore this message if you are satisfied with the current view.",
    "dontShowAgain": "Don't show this message again",
    "dismiss": "Dismiss"
  },
  "wysiwygEditor": {
    "table": {
      "insertTable": "Insert table",
      "addRowBefore": "Add row above",
      "addRowAfter": "Add row below",
      "deleteRow": "Delete row",
      "addColumnBefore": "Add column before",
      "addColumnAfter": "Add column after",
      "deleteColumn": "Delete column",
      "deleteTable": "Delete table"
    },
    "link": "Insert link",
    "image": "Insert image",
    "embed": "Embed video",
    "insert": "Insert",
    "original": "Original"
  },
  "meetingSummary": {
    "confirmConnectTitle": "Connect Meeting Summary to Project",
    "connectErrorMessage": "Failed to connect meeting summary to project. Please try again.",
    "connectErrorTitle": "Connection Failed",
    "connectInfoMessage": "This will create a copy of the meeting summary, including all to-dos and participants, within the selected project. You'll have both the personal summary and the project-linked summary.",
    "connectSuccess": "Meeting summary has been connected to project",
    "connectSuccessTitle": "Successfully Connected",
    "connectSuccessWithDelete": "Meeting summary has been connected to project, and the personal summary has been deleted.",
    "connectToProject": "Connect to Project",
    "connectToProjectButton": "Connect to Project",
    "connectToProjectTitle": "Connect to Beeboard Project",
    "deleteOriginalHelper": "Check this if you want to keep only the project-linked summary and remove your personal summary.",
    "deleteOriginalSummary": "Delete my personal summary after connecting",
    "loadingProjects": "Loading projects...",
    "noMeetingsHelper": "There are no meetings in this project where a summary can be connected to.",
    "noMeetingsInProject": "No meetings available",
    "noProjectsFound": "No projects found",
    "searchProjects": "Search projects...",
    "selectMeeting": "Select Meeting",
    "selectMeetingPlaceholder": "Choose a meeting (optional)...",
    "selectProject": "Select Project",
    "selectProjectDescription": "Choose a project to connect this meeting summary to. This will create a copy of the summary within the project context.",
    "selectProjectPlaceholder": "Choose a project...",
    "selectProjectTitle": "Select a Project",
    "selectedProject": "Selected Project"
  },
  "views": {
    "title": "Views",
    "myViews": "My Views",
    "managedViews": "Managed Views",
    "createView": "Create View",
    "editView": "Edit View",
    "deleteView": "Delete View",
    "forkView": "Copy to My Views",
    "noViews": "No views yet. Create your first view to get started.",
    "noResults": "No matching results for this view.",
    "personalEmptyTitle": "Your Personal Views",
    "personalEmptyDescription": "Personal views let you create custom dashboards that show activities and milestones across all projects you have access to. Each view applies your filters and displays only the data you're allowed to see.",
    "personalEmptyHint": "Get started quickly with one of these examples:",
    "presetActiveItems": "Active Items",
    "presetActiveItemsDesc": "All planned and underway activities and milestones across your projects.",
    "presetFullOverview": "Full Milestone and Activity Overview",
    "presetFullOverviewDesc": "All activities and milestones across your accessible projects.",
    "presetMilestonesOverview": "Milestones Overview",
    "presetMilestonesOverviewDesc": "All milestones with phases across your accessible projects at a glance.",
    "personal": "Personal",
    "managed": "Managed",
    "bypassUserRights": "Show all projects regardless of viewer's permissions",
    "entityTypes": "Entity Types",
    "entityTypesRequired": "At least one entity type must be selected",
    "activities": "Activities",
    "milestones": "Milestones",
    "projectSelection": "Projects",
    "projectProperties": "Project Properties",
    "templateFilter": "Template",
    "noTemplate": "(No template)",
    "activityFilters": "Activity Filters",
    "milestoneFilters": "Milestone Filters",
    "phaseFilters": "Phase Filters",
    "milestoneStates": "Milestone States",
    "milestoneStatuses": "Milestone Statuses",
    "milestoneDeadline": "Milestone Deadline",
    "titleSearch": "Title Search",
    "states": "States",
    "statuses": "Status Indicators",
    "deadlineRange": "Deadline Range",
    "deadlineFrom": "From",
    "deadlineTo": "To",
    "responsibility": "Responsibility",
    "approval": "Approval",
    "approvalFunctions": "Approvers (functions)",
    "users": "Users",
    "hasDocuments": "Has Documents",
    "myProjectsOnly": "My projects only",
    "usersProjectsOnly": "User's projects only",
    "allProjects": "All projects",
    "specificProjects": "{count} selected projects",
    "addPropertyFilter": "Add property filter",
    "filterValue": "Value",
    "selectPropertyFirst": "Select a property first",
    "addValueHint": "Type and press Enter",
    "exactMatch": "Exact",
    "containsMatch": "Contains",
    "results": {
      "projects": "{count} Projects",
      "activitiesCount": "{count} Activities",
      "milestonesCount": "{count} Milestones",
      "openInProject": "Open in Project",
      "refresh": "Refresh",
      "overdue": "Overdue",
      "backToViews": "Back to Views",
      "expandAll": "Expand All",
      "collapseAll": "Collapse All",
      "externalDateSync": {
        "inSync": "External date in sync"
      }
    },
    "confirmDelete": "Are you sure you want to delete this view?",
    "deleteSuccess": "View deleted successfully",
    "saveSuccess": "View saved successfully",
    "forkSuccess": "View copied to your views",
    "filtersActive": "{count} filters active",
    "shareWithUsers": "Share with users",
    "sharedWithCount": "Shared with {count} user(s)",
    "deadline": "Deadline",
    "panel": {
      "goToEntity": "Go to {entity}"
    },
    "swimlane": {
      "today": "Today",
      "clickToOpen": "Click to open in project",
      "clickToComment": "Click to view details, double-click to open in project",
      "items": "items",
      "more": "more",
      "zoomIn": "Zoom in",
      "zoomOut": "Zoom out",
      "zoomReset": "Reset zoom",
      "zoomToday": "Focus today",
      "togglePhases": "Toggle phases",
      "toggleActivities": "Toggle activities",
      "toggleMilestones": "Toggle milestones",
      "toggleLabels": "Toggle item labels",
      "labelModeTitle": "Title",
      "labelModeNumber": "Nr + Title",
      "labelModeDate": "Title + Date",
      "weekPrefix": "W",
      "manageProjects": "Manage projects",
      "showAllProjects": "Show all projects",
      "sortByDate": "Sort by start date",
      "sortByDateAsc": "Sort by start date (ascending)",
      "sortByDateDesc": "Sort by start date (descending)",
      "sortByTitle": "Sort by project title",
      "sortByTitleAsc": "Sort by project title (A-Z)",
      "sortByTitleDesc": "Sort by project title (Z-A)",
      "sortByNearest": "Sort by nearest deadline to today",
      "paintMode": "Highlight",
      "eraser": "Eraser",
      "clearHighlights": "Clear all highlights",
      "clearHighlightsTitle": "Clear highlights",
      "clearHighlightsConfirm": "Are you sure you want to clear all highlights?",
      "hatching": "Hatching pattern",
      "contentScale": "Content size",
      "colorLabel": "Label...",
      "colorLabels": "Color labels",
      "labelDragHint": "Drag to reposition, double-click to reset",
      "labelSettings": "Label settings",
      "labelModeSection": "Display",
      "labelWidthSection": "Max width",
      "labelPlacementMode": "Edit label positions",
      "resetLabels": "Reset all labels to default",
      "toggleProjectImages": "Show project images",
      "editHighlight": "Edit highlight",
      "highlightStart": "Start",
      "highlightEnd": "End",
      "exportPdf": "Export as PDF",
      "exportSuccess": "PDF exported successfully",
      "exportError": "PDF export failed. Please try again.",
      "presets": {
        "title": "Layouts",
        "default": "Default",
        "save": "Save",
        "saveAs": "Save as...",
        "rename": "Rename",
        "edit": "Edit window...",
        "namePlaceholder": "Layout name",
        "discard": "Discard changes",
        "resetAll": "Reset view",
        "deleteTitle": "Delete layout",
        "deleteConfirm": "Are you sure you want to delete the layout \"{name}\"?",
        "saveError": "Failed to save layout",
        "deleteError": "Failed to delete layout",
        "renameError": "Failed to rename layout",
        "rollingTooltip": "Rolling: -{past} weeks / +{future} weeks",
        "reanchorTooltip": "Re-anchor to today",
        "dialog": {
          "titleCreate": "Save layout",
          "titleEdit": "Edit layout \"{name}\"",
          "nameLabel": "Name",
          "windowLabel": "Time window",
          "modeAbsolute": "Absolute",
          "modeRolling": "Rolling",
          "hintAbsolute": "Saves the exact date range currently visible.",
          "hintRolling": "Always shows today minus past weeks to today plus future weeks.",
          "pastWeeksLabel": "Past (weeks)",
          "futureWeeksLabel": "Future (weeks)",
          "errorReservedName": "\"default\" is reserved.",
          "errorDuplicateName": "A layout with this name already exists.",
          "errorRollingWindow": "Enter non-negative whole numbers (past + future must be at least 1)."
        }
      }
    }
  },
  "easter": {
    "findTheEggs": "Find the golden eggs!",
    "congratulations": "You found all the eggs!",
    "allEggsFound": "Happy Easter from the Beeboard team!",
    "dismissSession": "Hide for now",
    "dismissForever": "Don't show again"
  },
  "news": {
    "title": "News",
    "empty": "No news yet",
    "manage": "Manage"
  },
  "help": {
    "title": "Help & Resources",
    "empty": "No resources available",
    "chatWithUs": "Chat with us",
    "moveToHeader": "Move to header",
    "moveToFloat": "Detach from header",
    "ai": {
      "buttonLabel": "Chat with AI",
      "headerTitle": "beeboard Help",
      "welcome": "Hi! I'm beeboard Help. Ask me anything about the application.",
      "conversation": "Chat with beeboard Help",
      "placeholder": "Type your message…",
      "inspecting": "Looking through the app…",
      "queued": "Waiting for a free spot…",
      "clearChat": "Clear chat",
      "close": "Close chat",
      "send": "Send message",
      "stop": "Stop generating",
      "stopped": "Response stopped.",
      "error": "Something went wrong. Please try again.",
      "interrupted": "The answer was interrupted. Please try again.",
      "rateLimited": "You've asked a lot of questions in a short time. Please wait {seconds} seconds, then try again.",
      "rateLimitedShort": "Please wait {seconds} s",
      "unavailable": "beeboard Help isn't available for your account."
    }
  },
  "inAppContent": {
    "title": "In-App Content",
    "tabTitle": "Content",
    "newsEntries": "News Entries",
    "knowledgeSources": "Knowledge Sources",
    "createNews": "Create News",
    "editNews": "Edit News",
    "createKnowledgeSource": "Create Knowledge Source",
    "editKnowledgeSource": "Edit Knowledge Source",
    "status": "Status",
    "statusValues": {
      "draft": "Draft",
      "published": "Published"
    },
    "targetRealms": "Target Realms",
    "targetRealmsLabel": "Target Realms",
    "targetRealmsHint": "Comma-separated realm names (empty = all realms)",
    "allRealms": "All realms",
    "publishedAt": "Published",
    "views": "Views",
    "url": "URL",
    "description": "Description",
    "iconLabel": "Icon Name",
    "sortOrder": "Sort Order",
    "contentLabel": "Content",
    "titleLabel": "Title",
    "languageDE": "German",
    "languageEN": "English",
    "globallyManaged": "Globally managed",
    "targetUserGroupsLabel": "Target User Groups",
    "targetUsersLabel": "Target Specific Users",
    "noUserTargeting": "No specific users",
    "noUserGroupTargeting": "No user groups",
    "userGroups": {
      "allProjectResponsiblesAndEditors": "All project responsibles and editors",
      "allProjectResponsibles": "All project responsibles",
      "allProjectMembers": "All project members"
    }
  },
  "presence": {
    "showLiveCursors": "Show live cursors",
    "hideLiveCursors": "Hide live cursors",
    "follow": "Follow view",
    "unfollow": "Stop following",
    "followingBanner": "Following {name}",
    "beingFollowedBanner": "{names} following you",
    "aiAssistant": "AI Assistant"
  },
  "validation": {
    "required": "This field is required",
    "minLength": "Must be at least {min} characters",
    "maxLength": "Must be at most {max} characters",
    "pattern": "Invalid format",
    "minValue": "Must be at least {min}",
    "maxValue": "Must be at most {max}"
  },
  "templateQuality": {
    "sharedDocument": {
      "needsHandover": "Still needs the handover",
      "alreadyWired": "Already passed on",
      "likelyFrom": "Likely receives it from “{title}” — open this activity's documents to model the handover as an input",
      "likelyTo": "Probably produces the document — likely hands it over to “{title}”. Open this activity's documents to model it as an output",
      "less": "Show less",
      "more": "+{count} more",
      "wired": "Already passed on as an input/output",
      "notWiredConnected": "Connected on the map, but the document is not yet passed on as an input/output — open this activity's documents",
      "notWiredUnconnected": "Not connected to the other sharing activities — consider whether a handover belongs here"
    },
    "checks": {
      "dangling_activity": {
        "label": "Unconnected activity",
        "description": "Flags activities that are not wired into the flow of the map. The map's own first and last activity are not flagged for the end they cannot have.",
        "message": "This activity has no predecessor or no successor. Connect it to the rest of the map.",
        "messageNoPredecessor": "This activity has no predecessor — nothing leads into it.",
        "messageNoSuccessor": "This activity has no successor — nothing follows it.",
        "messageNeither": "This activity has no predecessor and no successor — it is not connected to the map at all.",
        "shortLabel": "Not connected"
      },
      "unassigned_function_activity": {
        "label": "Activity without a responsible function",
        "description": "Flags activities that have no responsible function assigned.",
        "message": "This activity has no responsible function assigned.",
        "shortLabel": "No responsible function"
      },
      "ai_suggest_function_activity": {
        "label": "Suggested responsible function (activity)",
        "description": "Uses AI to suggest which of the template's functions should be responsible for an activity that has none.",
        "message": "No responsible function is assigned. Suggested function:",
        "shortLabel": "Suggested responsible function"
      },
      "unassigned_function_completion_criterion": {
        "label": "Completion criterion without a responsible function",
        "description": "Flags completion criteria that have no responsible function assigned.",
        "message": "This completion criterion has no responsible function assigned.",
        "shortLabel": "No responsible function"
      },
      "ai_suggest_function_completion_criterion": {
        "label": "Suggested responsible function (completion criterion)",
        "description": "Uses AI to suggest which of the template's functions should be responsible for a completion criterion that has none.",
        "message": "No responsible function is assigned. Suggested function:",
        "shortLabel": "Suggested responsible function"
      },
      "unassigned_function_phase": {
        "label": "Phase without a responsible function",
        "description": "Flags phases that have no responsible function assigned.",
        "message": "This phase has no responsible function assigned.",
        "shortLabel": "No responsible function"
      },
      "shared_document": {
        "label": "Document shared by several activities",
        "description": "Flags documents attached to more than one activity — usually a sign the document should be passed on as an input/output instead. Documents whose sharing is already modelled as input/output are not flagged.",
        "message": "This document is attached to several activities. Consider passing it on between activities as an input/output instead.",
        "shortLabel": "Shared across activities"
      },
      "missing_description_activity": {
        "label": "Activity without a description",
        "description": "Flags activities that have no description.",
        "message": "This activity has no description.",
        "shortLabel": "No description"
      },
      "missing_description_completion_criterion": {
        "label": "Completion criterion without a description",
        "description": "Flags completion criteria that have no description.",
        "message": "This completion criterion has no description.",
        "shortLabel": "No description"
      },
      "missing_description_milestone": {
        "label": "Milestone without a description",
        "description": "Flags milestones that have no description.",
        "message": "This milestone has no description.",
        "shortLabel": "No description"
      },
      "missing_title_activity": {
        "label": "Activity without a title",
        "description": "Flags activities that have no title.",
        "message": "This activity has no title.",
        "shortLabel": "No title"
      },
      "missing_title_milestone": {
        "label": "Milestone without a title",
        "description": "Flags milestones that have no title.",
        "message": "This milestone has no title.",
        "shortLabel": "No title"
      },
      "ai_title_quality_activity": {
        "label": "Activity title quality (AI)",
        "description": "Lets the AI judge whether activity titles are clear, specific, and consistently phrased.",
        "message": "The AI suggests improving this activity title.",
        "shortLabel": "Suggested title"
      },
      "ai_title_quality_milestone": {
        "label": "Milestone title quality (AI)",
        "description": "Lets the AI judge whether milestone titles are clear, specific, and consistently phrased.",
        "message": "The AI suggests improving this milestone title.",
        "shortLabel": "Suggested title"
      },
      "ai_description_quality_activity": {
        "label": "Activity description quality (AI)",
        "description": "Lets the AI judge whether activity descriptions actually explain the work to be done.",
        "message": "The AI suggests improving this activity description.",
        "shortLabel": "Suggested description"
      },
      "ai_description_quality_completion_criterion": {
        "label": "Completion criterion description quality (AI)",
        "description": "Lets the AI judge whether completion criteria describe a verifiable result.",
        "message": "The AI suggests improving this completion criterion description.",
        "shortLabel": "Suggested description"
      },
      "ai_description_quality_milestone": {
        "label": "Milestone description quality (AI)",
        "description": "Lets the AI judge whether milestone descriptions explain what has been achieved.",
        "message": "The AI suggests improving this milestone description.",
        "shortLabel": "Suggested description"
      }
    },
    "panel": {
      "title": "Quality check",
      "close": "Close",
      "runAiCheck": "Run AI check",
      "runError": "The AI quality check could not be completed.",
      "progress": "Checked {processed} of {total}",
      "noFindings": "No quality issues found.",
      "untitled": "Untitled",
      "proposal": "Suggested text",
      "aiBadge": "AI",
      "aiBadgeTooltip": "Suggested by AI",
      "apply": "Apply",
      "applySuccess": "The suggestion has been applied.",
      "applyError": "The suggestion could not be applied.",
      "dismiss": "Ignore this finding",
      "dismissError": "The finding could not be updated.",
      "showIgnored": "Show ignored",
      "ignoredTitle": "Ignored findings",
      "noIgnored": "No findings have been ignored.",
      "unignore": "Restore",
      "markSolved": "Mark as solved",
      "toggleGroup": "Expand or collapse",
      "suggestedFunction": "Suggested function"
    },
    "tab": {
      "goToFix": "Go to where this is fixed"
    },
    "setup": {
      "title": "Quality check settings",
      "subtitle": "Choose which checks to run this time. This selection applies to this run only — the saved defaults are unchanged.",
      "confirm": "Show findings"
    },
    "entities": {
      "activity": "Activities",
      "completion_criterion": "Completion criteria",
      "milestone": "Milestones",
      "phase": "Phases",
      "document": "Documents"
    },
    "settings": {
      "navLabel": "Quality checks",
      "templateTitle": "Quality checks",
      "templateSubtitle": "Choose which checks run on this template. Checks you do not override follow the company default.",
      "companyTitle": "Quality check defaults",
      "companySubtitle": "These defaults apply to every template in your company. Each template can override them individually.",
      "inherited": "Inherited",
      "overridden": "Overridden",
      "overriddenCount": "{count} overridden",
      "reset": "Reset",
      "loadError": "The quality check settings could not be loaded.",
      "saveError": "The quality check settings could not be saved.",
      "enabledCount": "{enabled} of {total} on",
      "aiTag": "AI"
    }
  },
  "projectMail": {
    "attachments": "Attachments",
    "attachmentsNotStored": "The files themselves are not stored in beeboard.",
    "detailFailed": "Could not load this mail",
    "dragHint": "Drag this mail onto the map to create an activity from it, or onto an existing activity to add it as a completion criterion, action or comment.",
    "hasAttachments": "Attachments: {count}",
    "noBody": "This mail has no content.",
    "noSubject": "(no subject)",
    "addressTitle": "Email address",
    "on": "On",
    "off": "Off",
    "copy": "Copy",
    "enable": "Enable",
    "disable": "Turn off",
    "aliasLabel": "Address name",
    "aliasRules": "Lowercase letters, digits, dots and hyphens. Must start and end with a letter or digit.",
    "previewLabel": "New address:",
    "addressSaved": "Project mail address saved",
    "addressCopied": "Address copied",
    "addressCopyFailed": "Could not copy the address",
    "addressTaken": "This address is already in use by another project. Please choose a different name.",
    "disabled": "Project mail turned off",
    "responsibleOnly": "Only the project responsible can change the project mail address.",
    "retentionHint": "Mail is kept for {days} days from the day it arrives, then deleted — whether or not anything was created from it.",
    "formerAddresses": "Previous addresses:",
    "formerAddressesHint": "Mail sent to a previous address still reaches this project, so senders who saved the old one still get through.",
    "disableConfirmTitle": "Turn off project mail?",
    "disableConfirmMessage": "New mail to this project’s address will be discarded. Mail already received stays in the “Import Tasks” sidebar until it reaches {days} days old.",
    "deleteMail": "Delete mail",
    "loadMore": "Load more ({loaded} of {total})",
    "loadingMore": "Loading…",
    "noMail": "No mail yet. Anything sent to {address} appears here.",
    "noMailNoAddress": "No mail yet.",
    "deleteTitle": "Delete this mail?",
    "deleteMessage": "“{subject}” and its content are removed. This cannot be undone.",
    "deleteAfterConvertTitle": "Delete this mail?",
    "deleteAfterConvertMessage": "“{title}” was created from this mail. Deleting the mail removes its content — what you just created stays. Keep the mail if you still want to create something else from it; it is deleted automatically {days} days after it arrived.",
    "deleteAfterCommentMessage": "The mail was added as a comment to “{title}”. Deleting the mail removes its content — the comment stays. Keep the mail if you still want to create something else from it; it is deleted automatically {days} days after it arrived.",
    "commentAdded": "Comment added",
    "commentFailed": "Could not add the comment.",
    "commentFrom": "From",
    "commentReceived": "Received",
    "commentSubject": "Subject",
    "commentSenderFailed": "⚠ Sender not confirmed – the sender address may be forged",
    "commentAttachmentsNotStored": "not stored in beeboard",
    "unknownSender": "Unknown sender",
    "deleted": "Mail deleted",
    "deleteFailed": "Could not delete the mail",
    "embeddedImages": "Embedded images",
    "senderVerified": "Sender verified",
    "senderVerifiedHint": "The sending domain confirmed this message really came from it (DMARC pass).",
    "senderFailed": "Sender not confirmed",
    "senderFailedHint": "The sending domain did not confirm this message (DMARC fail). The address it claims to be from may be forged.",
    "senderUnverified": "Sender unknown",
    "senderUnverifiedHint": "The sending domain publishes no policy we can check against, which is common. Nothing is wrong, but nothing is confirmed either."
  }
}
